const fontAwesomeIcons = [
  'fa-0',
  'fa-1',
  'fa-2',
  'fa-3',
  'fa-4',
  'fa-5',
  'fa-6',
  'fa-7',
  'fa-8',
  'fa-9',
  'fa-00',
  'fa-360-degrees',
  'fa-a',
  'fa-abacus',
  'fa-accent-grave',
  'fa-acorn',
  'fa-address-book',
  'fa-contact-book',
  'fa-address-card',
  'fa-contact-card',
  'fa-vcard',
  'fa-air-conditioner',
  'fa-airplay',
  'fa-alarm-clock',
  'fa-alarm-exclamation',
  'fa-alarm-plus',
  'fa-alarm-snooze',
  'fa-album',
  'fa-album-circle-plus',
  'fa-album-circle-user',
  'fa-album-collection',
  'fa-album-collection-circle-plus',
  'fa-album-collection-circle-user',
  'fa-alicorn',
  'fa-alien',
  'fa-alien-8bit',
  'fa-alien-monster',
  'fa-align-center',
  'fa-align-justify',
  'fa-align-left',
  'fa-align-right',
  'fa-align-slash',
  'fa-alt',
  'fa-amp-guitar',
  'fa-ampersand',
  'fa-anchor',
  'fa-angel',
  'fa-angle',
  'fa-angle-90',
  'fa-angle-down',
  'fa-angle-left',
  'fa-angle-right',
  'fa-angle-up',
  'fa-angles-down',
  'fa-angle-double-down',
  'fa-angles-left',
  'fa-angle-double-left',
  'fa-angles-right',
  'fa-angle-double-right',
  'fa-angles-up',
  'fa-angle-double-up',
  'fa-ankh',
  'fa-apartment',
  'fa-aperture',
  'fa-apostrophe',
  'fa-apple-core',
  'fa-apple-whole',
  'fa-apple-alt',
  'fa-archway',
  'fa-arrow-down',
  'fa-arrow-down-1-9',
  'fa-sort-numeric-asc',
  'fa-sort-numeric-down',
  'fa-arrow-down-9-1',
  'fa-sort-numeric-desc',
  'fa-sort-numeric-down-alt',
  'fa-arrow-down-a-z',
  'fa-sort-alpha-asc',
  'fa-sort-alpha-down',
  'fa-arrow-down-arrow-up',
  'fa-sort-alt',
  'fa-arrow-down-big-small',
  'fa-sort-size-down',
  'fa-arrow-down-from-dotted-line',
  'fa-arrow-down-from-line',
  'fa-arrow-from-top',
  'fa-arrow-down-left',
  'fa-arrow-down-left-and-arrow-up-right-to-center',
  'fa-arrow-down-long',
  'fa-long-arrow-down',
  'fa-arrow-down-right',
  'fa-arrow-down-short-wide',
  'fa-sort-amount-desc',
  'fa-sort-amount-down-alt',
  'fa-arrow-down-small-big',
  'fa-sort-size-down-alt',
  'fa-arrow-down-square-triangle',
  'fa-sort-shapes-down-alt',
  'fa-arrow-down-to-bracket',
  'fa-arrow-down-to-dotted-line',
  'fa-arrow-down-to-line',
  'fa-arrow-to-bottom',
  'fa-arrow-down-to-square',
  'fa-arrow-down-triangle-square',
  'fa-sort-shapes-down',
  'fa-arrow-down-wide-short',
  'fa-sort-amount-asc',
  'fa-sort-amount-down',
  'fa-arrow-down-z-a',
  'fa-sort-alpha-desc',
  'fa-sort-alpha-down-alt',
  'fa-arrow-left',
  'fa-arrow-left-from-line',
  'fa-arrow-from-right',
  'fa-arrow-left-long',
  'fa-long-arrow-left',
  'fa-arrow-left-long-to-line',
  'fa-arrow-left-to-line',
  'fa-arrow-to-left',
  'fa-arrow-pointer',
  'fa-mouse-pointer',
  'fa-arrow-right',
  'fa-arrow-right-arrow-left',
  'fa-exchange',
  'fa-arrow-right-from-bracket',
  'fa-sign-out',
  'fa-arrow-right-from-line',
  'fa-arrow-from-left',
  'fa-arrow-right-long',
  'fa-long-arrow-right',
  'fa-arrow-right-long-to-line',
  'fa-arrow-right-to-bracket',
  'fa-sign-in',
  'fa-arrow-right-to-line',
  'fa-arrow-to-right',
  'fa-arrow-rotate-left',
  'fa-arrow-left-rotate',
  'fa-arrow-rotate-back',
  'fa-arrow-rotate-backward',
  'fa-undo',
  'fa-arrow-rotate-right',
  'fa-arrow-right-rotate',
  'fa-arrow-rotate-forward',
  'fa-redo',
  'fa-arrow-trend-down',
  'fa-arrow-trend-up',
  'fa-arrow-turn-down',
  'fa-level-down',
  'fa-arrow-turn-down-left',
  'fa-arrow-turn-down-right',
  'fa-arrow-turn-up',
  'fa-level-up',
  'fa-arrow-up',
  'fa-arrow-up-1-9',
  'fa-sort-numeric-up',
  'fa-arrow-up-9-1',
  'fa-sort-numeric-up-alt',
  'fa-arrow-up-a-z',
  'fa-sort-alpha-up',
  'fa-arrow-up-arrow-down',
  'fa-sort-up-down',
  'fa-arrow-up-big-small',
  'fa-sort-size-up',
  'fa-arrow-up-from-bracket',
  'fa-arrow-up-from-dotted-line',
  'fa-arrow-up-from-line',
  'fa-arrow-from-bottom',
  'fa-arrow-up-from-square',
  'fa-arrow-up-left',
  'fa-arrow-up-left-from-circle',
  'fa-arrow-up-long',
  'fa-long-arrow-up',
  'fa-arrow-up-right',
  'fa-arrow-up-right-and-arrow-down-left-from-center',
  'fa-arrow-up-right-from-square',
  'fa-external-link',
  'fa-arrow-up-short-wide',
  'fa-sort-amount-up-alt',
  'fa-arrow-up-small-big',
  'fa-sort-size-up-alt',
  'fa-arrow-up-square-triangle',
  'fa-sort-shapes-up-alt',
  'fa-arrow-up-to-dotted-line',
  'fa-arrow-up-to-line',
  'fa-arrow-to-top',
  'fa-arrow-up-triangle-square',
  'fa-sort-shapes-up',
  'fa-arrow-up-wide-short',
  'fa-sort-amount-up',
  'fa-arrow-up-z-a',
  'fa-sort-alpha-up-alt',
  'fa-arrows-cross',
  'fa-arrows-from-dotted-line',
  'fa-arrows-from-line',
  'fa-arrows-left-right',
  'fa-arrows-h',
  'fa-arrows-maximize',
  'fa-expand-arrows',
  'fa-arrows-minimize',
  'fa-compress-arrows',
  'fa-arrows-repeat',
  'fa-repeat-alt',
  'fa-arrows-repeat-1',
  'fa-repeat-1-alt',
  'fa-arrows-retweet',
  'fa-retweet-alt',
  'fa-arrows-rotate',
  'fa-refresh',
  'fa-sync',
  'fa-arrows-to-dotted-line',
  'fa-arrows-to-line',
  'fa-arrows-up-down',
  'fa-arrows-v',
  'fa-arrows-up-down-left-right',
  'fa-arrows',
  'fa-asterisk',
  'fa-at',
  'fa-atom',
  'fa-atom-simple',
  'fa-atom-alt',
  'fa-audio-description',
  'fa-audio-description-slash',
  'fa-austral-sign',
  'fa-avocado',
  'fa-award',
  'fa-award-simple',
  'fa-axe',
  'fa-axe-battle',
  'fa-b',
  'fa-baby',
  'fa-baby-carriage',
  'fa-carriage-baby',
  'fa-backpack',
  'fa-backward',
  'fa-backward-fast',
  'fa-fast-backward',
  'fa-backward-step',
  'fa-step-backward',
  'fa-bacon',
  'fa-bacteria',
  'fa-bacterium',
  'fa-badge',
  'fa-badge-check',
  'fa-badge-dollar',
  'fa-badge-percent',
  'fa-badge-sheriff',
  'fa-badger-honey',
  'fa-badminton',
  'fa-bag-shopping',
  'fa-shopping-bag',
  'fa-bagel',
  'fa-bags-shopping',
  'fa-baguette',
  'fa-bahai',
  'fa-baht-sign',
  'fa-ball-pile',
  'fa-balloon',
  'fa-balloons',
  'fa-ballot',
  'fa-ballot-check',
  'fa-ban',
  'fa-cancel',
  'fa-ban-bug',
  'fa-debug',
  'fa-ban-parking',
  'fa-parking-circle-slash',
  'fa-ban-smoking',
  'fa-smoking-ban',
  'fa-banana',
  'fa-bandage',
  'fa-band-aid',
  'fa-bangladeshi-taka-sign',
  'fa-banjo',
  'fa-barcode',
  'fa-barcode-read',
  'fa-barcode-scan',
  'fa-bars',
  'fa-navicon',
  'fa-bars-filter',
  'fa-bars-progress',
  'fa-tasks-alt',
  'fa-bars-sort',
  'fa-bars-staggered',
  'fa-reorder',
  'fa-stream',
  'fa-baseball',
  'fa-baseball-ball',
  'fa-baseball-bat-ball',
  'fa-basket-shopping',
  'fa-shopping-basket',
  'fa-basket-shopping-simple',
  'fa-shopping-basket-alt',
  'fa-basketball',
  'fa-basketball-ball',
  'fa-basketball-hoop',
  'fa-bat',
  'fa-bath',
  'fa-bathtub',
  'fa-battery-bolt',
  'fa-battery-empty',
  'fa-battery-0',
  'fa-battery-exclamation',
  'fa-battery-full',
  'fa-battery',
  'fa-battery-5',
  'fa-battery-half',
  'fa-battery-3',
  'fa-battery-low',
  'fa-battery-1',
  'fa-battery-quarter',
  'fa-battery-2',
  'fa-battery-slash',
  'fa-battery-three-quarters',
  'fa-battery-4',
  'fa-bed',
  'fa-bed-bunk',
  'fa-bed-empty',
  'fa-bed-front',
  'fa-bed-alt',
  'fa-bed-pulse',
  'fa-procedures',
  'fa-bee',
  'fa-beer-mug',
  'fa-beer-foam',
  'fa-beer-mug-empty',
  'fa-beer',
  'fa-bell',
  'fa-bell-concierge',
  'fa-concierge-bell',
  'fa-bell-exclamation',
  'fa-bell-on',
  'fa-bell-plus',
  'fa-bell-school',
  'fa-bell-school-slash',
  'fa-bell-slash',
  'fa-bells',
  'fa-bench-tree',
  'fa-bezier-curve',
  'fa-bicycle',
  'fa-binary',
  'fa-binary-circle-check',
  'fa-binary-lock',
  'fa-binary-slash',
  'fa-binoculars',
  'fa-biohazard',
  'fa-bird',
  'fa-bitcoin-sign',
  'fa-blanket',
  'fa-blanket-fire',
  'fa-blender',
  'fa-blender-phone',
  'fa-blinds',
  'fa-blinds-open',
  'fa-blinds-raised',
  'fa-block',
  'fa-block-brick',
  'fa-wall-brick',
  'fa-block-brick-fire',
  'fa-firewall',
  'fa-block-question',
  'fa-block-quote',
  'fa-blog',
  'fa-blueberries',
  'fa-bold',
  'fa-bolt',
  'fa-zap',
  'fa-bolt-auto',
  'fa-bolt-lightning',
  'fa-bolt-slash',
  'fa-bomb',
  'fa-bone',
  'fa-bone-break',
  'fa-bong',
  'fa-book',
  'fa-book-arrow-right',
  'fa-book-arrow-up',
  'fa-book-atlas',
  'fa-atlas',
  'fa-book-bible',
  'fa-bible',
  'fa-book-blank',
  'fa-book-alt',
  'fa-book-bookmark',
  'fa-book-circle-arrow-right',
  'fa-book-circle-arrow-up',
  'fa-book-copy',
  'fa-book-font',
  'fa-book-heart',
  'fa-book-journal-whills',
  'fa-journal-whills',
  'fa-book-medical',
  'fa-book-open',
  'fa-book-open-cover',
  'fa-book-open-alt',
  'fa-book-open-reader',
  'fa-book-reader',
  'fa-book-quran',
  'fa-quran',
  'fa-book-section',
  'fa-book-law',
  'fa-book-skull',
  'fa-book-dead',
  'fa-book-sparkles',
  'fa-book-spells',
  'fa-book-tanakh',
  'fa-tanakh',
  'fa-book-user',
  'fa-bookmark',
  'fa-bookmark-slash',
  'fa-books',
  'fa-books-medical',
  'fa-boombox',
  'fa-boot',
  'fa-boot-heeled',
  'fa-booth-curtain',
  'fa-border-all',
  'fa-border-bottom',
  'fa-border-bottom-right',
  'fa-border-style-alt',
  'fa-border-center-h',
  'fa-border-center-v',
  'fa-border-inner',
  'fa-border-left',
  'fa-border-none',
  'fa-border-outer',
  'fa-border-right',
  'fa-border-top',
  'fa-border-top-left',
  'fa-border-style',
  'fa-bow-arrow',
  'fa-bowl-chopsticks',
  'fa-bowl-chopsticks-noodles',
  'fa-bowl-hot',
  'fa-soup',
  'fa-bowl-rice',
  'fa-bowl-scoop',
  'fa-bowl-shaved-ice',
  'fa-bowl-scoops',
  'fa-bowl-soft-serve',
  'fa-bowl-spoon',
  'fa-bowling-ball',
  'fa-bowling-ball-pin',
  'fa-bowling-pins',
  'fa-box',
  'fa-box-archive',
  'fa-archive',
  'fa-box-ballot',
  'fa-box-check',
  'fa-box-circle-check',
  'fa-box-dollar',
  'fa-box-usd',
  'fa-box-heart',
  'fa-box-open',
  'fa-box-open-full',
  'fa-box-full',
  'fa-box-taped',
  'fa-box-alt',
  'fa-box-tissue',
  'fa-boxes-stacked',
  'fa-boxes',
  'fa-boxes-alt',
  'fa-boxing-glove',
  'fa-glove-boxing',
  'fa-bracket-curly',
  'fa-bracket-curly-left',
  'fa-bracket-curly-right',
  'fa-bracket-round',
  'fa-parenthesis',
  'fa-bracket-round-right',
  'fa-bracket-square',
  'fa-bracket',
  'fa-bracket-left',
  'fa-bracket-square-right',
  'fa-brackets-curly',
  'fa-brackets-round',
  'fa-parentheses',
  'fa-brackets-square',
  'fa-brackets',
  'fa-braille',
  'fa-brain',
  'fa-brain-arrow-curved-right',
  'fa-mind-share',
  'fa-brain-circuit',
  'fa-brake-warning',
  'fa-brazilian-real-sign',
  'fa-bread-loaf',
  'fa-bread-slice',
  'fa-bread-slice-butter',
  'fa-briefcase',
  'fa-briefcase-arrow-right',
  'fa-briefcase-blank',
  'fa-briefcase-medical',
  'fa-brightness',
  'fa-brightness-low',
  'fa-bring-forward',
  'fa-bring-front',
  'fa-broccoli',
  'fa-broom',
  'fa-broom-ball',
  'fa-quidditch',
  'fa-quidditch-broom-ball',
  'fa-browser',
  'fa-browsers',
  'fa-brush',
  'fa-bug',
  'fa-bug-slash',
  'fa-building',
  'fa-building-columns',
  'fa-bank',
  'fa-institution',
  'fa-museum',
  'fa-university',
  'fa-buildings',
  'fa-bullhorn',
  'fa-bullseye',
  'fa-bullseye-arrow',
  'fa-bullseye-pointer',
  'fa-burger',
  'fa-hamburger',
  'fa-burger-cheese',
  'fa-cheeseburger',
  'fa-burger-fries',
  'fa-burger-glass',
  'fa-burger-lettuce',
  'fa-burger-soda',
  'fa-burrito',
  'fa-bus',
  'fa-bus-school',
  'fa-bus-simple',
  'fa-bus-alt',
  'fa-business-time',
  'fa-briefcase-clock',
  'fa-butter',
  'fa-c',
  'fa-cabin',
  'fa-cabinet-filing',
  'fa-cable-car',
  'fa-cactus',
  'fa-cake-candles',
  'fa-birthday-cake',
  'fa-cake',
  'fa-cake-slice',
  'fa-shortcake',
  'fa-calculator',
  'fa-calculator-simple',
  'fa-calculator-alt',
  'fa-calendar',
  'fa-calendar-arrow-down',
  'fa-calendar-download',
  'fa-calendar-arrow-up',
  'fa-calendar-upload',
  'fa-calendar-check',
  'fa-calendar-circle-exclamation',
  'fa-calendar-circle-minus',
  'fa-calendar-circle-plus',
  'fa-calendar-circle-user',
  'fa-calendar-clock',
  'fa-calendar-time',
  'fa-calendar-day',
  'fa-calendar-days',
  'fa-calendar-alt',
  'fa-calendar-exclamation',
  'fa-calendar-heart',
  'fa-calendar-image',
  'fa-calendar-lines',
  'fa-calendar-note',
  'fa-calendar-lines-pen',
  'fa-calendar-minus',
  'fa-calendar-pen',
  'fa-calendar-edit',
  'fa-calendar-plus',
  'fa-calendar-range',
  'fa-calendar-star',
  'fa-calendar-week',
  'fa-calendar-xmark',
  'fa-calendar-times',
  'fa-calendars',
  'fa-camcorder',
  'fa-video-handheld',
  'fa-camera',
  'fa-camera-alt',
  'fa-camera-cctv',
  'fa-cctv',
  'fa-camera-movie',
  'fa-camera-polaroid',
  'fa-camera-retro',
  'fa-camera-rotate',
  'fa-camera-security',
  'fa-camera-home',
  'fa-camera-slash',
  'fa-camera-viewfinder',
  'fa-screenshot',
  'fa-camera-web',
  'fa-webcam',
  'fa-camera-web-slash',
  'fa-webcam-slash',
  'fa-campfire',
  'fa-campground',
  'fa-can-food',
  'fa-candle-holder',
  'fa-candy',
  'fa-candy-bar',
  'fa-chocolate-bar',
  'fa-candy-cane',
  'fa-candy-corn',
  'fa-cannabis',
  'fa-capsules',
  'fa-car',
  'fa-automobile',
  'fa-car-battery',
  'fa-battery-car',
  'fa-car-bolt',
  'fa-car-building',
  'fa-car-bump',
  'fa-car-bus',
  'fa-car-circle-bolt',
  'fa-car-crash',
  'fa-car-garage',
  'fa-car-mirrors',
  'fa-car-rear',
  'fa-car-alt',
  'fa-car-side',
  'fa-car-side-bolt',
  'fa-car-tilt',
  'fa-car-wash',
  'fa-car-wrench',
  'fa-car-mechanic',
  'fa-caravan',
  'fa-caravan-simple',
  'fa-caravan-alt',
  'fa-card-club',
  'fa-card-diamond',
  'fa-card-heart',
  'fa-card-spade',
  'fa-cards',
  'fa-caret-down',
  'fa-caret-left',
  'fa-caret-right',
  'fa-caret-up',
  'fa-carrot',
  'fa-cars',
  'fa-cart-arrow-down',
  'fa-cart-arrow-up',
  'fa-cart-circle-arrow-down',
  'fa-cart-circle-arrow-up',
  'fa-cart-circle-check',
  'fa-cart-circle-exclamation',
  'fa-cart-circle-plus',
  'fa-cart-circle-xmark',
  'fa-cart-flatbed',
  'fa-dolly-flatbed',
  'fa-cart-flatbed-boxes',
  'fa-dolly-flatbed-alt',
  'fa-cart-flatbed-empty',
  'fa-dolly-flatbed-empty',
  'fa-cart-flatbed-suitcase',
  'fa-luggage-cart',
  'fa-cart-minus',
  'fa-cart-plus',
  'fa-cart-shopping',
  'fa-shopping-cart',
  'fa-cart-shopping-fast',
  'fa-cart-xmark',
  'fa-cash-register',
  'fa-cassette-betamax',
  'fa-betamax',
  'fa-cassette-tape',
  'fa-cassette-vhs',
  'fa-vhs',
  'fa-castle',
  'fa-cat',
  'fa-cat-space',
  'fa-cauldron',
  'fa-cedi-sign',
  'fa-cent-sign',
  'fa-certificate',
  'fa-chair',
  'fa-chair-office',
  'fa-chalkboard',
  'fa-blackboard',
  'fa-chalkboard-user',
  'fa-chalkboard-teacher',
  'fa-champagne-glass',
  'fa-glass-champagne',
  'fa-champagne-glasses',
  'fa-glass-cheers',
  'fa-charging-station',
  'fa-chart-area',
  'fa-area-chart',
  'fa-chart-bar',
  'fa-bar-chart',
  'fa-chart-bullet',
  'fa-chart-candlestick',
  'fa-chart-column',
  'fa-chart-gantt',
  'fa-chart-line',
  'fa-line-chart',
  'fa-chart-line-down',
  'fa-chart-line-up',
  'fa-chart-mixed',
  'fa-analytics',
  'fa-chart-network',
  'fa-chart-pie',
  'fa-pie-chart',
  'fa-chart-pie-simple',
  'fa-chart-pie-alt',
  'fa-chart-pyramid',
  'fa-chart-radar',
  'fa-chart-scatter',
  'fa-chart-scatter-3d',
  'fa-chart-scatter-bubble',
  'fa-chart-simple',
  'fa-chart-simple-horizontal',
  'fa-chart-tree-map',
  'fa-chart-user',
  'fa-user-chart',
  'fa-chart-waterfall',
  'fa-check',
  'fa-check-double',
  'fa-check-to-slot',
  'fa-vote-yea',
  'fa-cheese',
  'fa-cheese-swiss',
  'fa-cherries',
  'fa-chess',
  'fa-chess-bishop',
  'fa-chess-bishop-piece',
  'fa-chess-bishop-alt',
  'fa-chess-board',
  'fa-chess-clock',
  'fa-chess-clock-flip',
  'fa-chess-clock-alt',
  'fa-chess-king',
  'fa-chess-king-piece',
  'fa-chess-king-alt',
  'fa-chess-knight',
  'fa-chess-knight-piece',
  'fa-chess-knight-alt',
  'fa-chess-pawn',
  'fa-chess-pawn-piece',
  'fa-chess-pawn-alt',
  'fa-chess-queen',
  'fa-chess-queen-piece',
  'fa-chess-queen-alt',
  'fa-chess-rook',
  'fa-chess-rook-piece',
  'fa-chess-rook-alt',
  'fa-chestnut',
  'fa-chevron-down',
  'fa-chevron-left',
  'fa-chevron-right',
  'fa-chevron-up',
  'fa-chevrons-down',
  'fa-chevron-double-down',
  'fa-chevrons-left',
  'fa-chevron-double-left',
  'fa-chevrons-right',
  'fa-chevron-double-right',
  'fa-chevrons-up',
  'fa-chevron-double-up',
  'fa-child',
  'fa-chimney',
  'fa-chopsticks',
  'fa-church',
  'fa-circle',
  'fa-circle-0',
  'fa-circle-1',
  'fa-circle-2',
  'fa-circle-3',
  'fa-circle-4',
  'fa-circle-5',
  'fa-circle-6',
  'fa-circle-7',
  'fa-circle-8',
  'fa-circle-9',
  'fa-circle-a',
  'fa-circle-ampersand',
  'fa-circle-arrow-down',
  'fa-arrow-circle-down',
  'fa-circle-arrow-down-left',
  'fa-circle-arrow-down-right',
  'fa-circle-arrow-left',
  'fa-arrow-circle-left',
  'fa-circle-arrow-right',
  'fa-arrow-circle-right',
  'fa-circle-arrow-up',
  'fa-arrow-circle-up',
  'fa-circle-arrow-up-left',
  'fa-circle-arrow-up-right',
  'fa-circle-b',
  'fa-circle-bolt',
  'fa-circle-book-open',
  'fa-book-circle',
  'fa-circle-bookmark',
  'fa-bookmark-circle',
  'fa-circle-c',
  'fa-circle-calendar',
  'fa-calendar-circle',
  'fa-circle-camera',
  'fa-camera-circle',
  'fa-circle-caret-down',
  'fa-caret-circle-down',
  'fa-circle-caret-left',
  'fa-caret-circle-left',
  'fa-circle-caret-right',
  'fa-caret-circle-right',
  'fa-circle-caret-up',
  'fa-caret-circle-up',
  'fa-circle-check',
  'fa-check-circle',
  'fa-circle-chevron-down',
  'fa-chevron-circle-down',
  'fa-circle-chevron-left',
  'fa-chevron-circle-left',
  'fa-circle-chevron-right',
  'fa-chevron-circle-right',
  'fa-circle-chevron-up',
  'fa-chevron-circle-up',
  'fa-circle-d',
  'fa-circle-dashed',
  'fa-circle-divide',
  'fa-circle-dollar',
  'fa-dollar-circle',
  'fa-usd-circle',
  'fa-circle-dollar-to-slot',
  'fa-donate',
  'fa-circle-dot',
  'fa-dot-circle',
  'fa-circle-down',
  'fa-arrow-alt-circle-down',
  'fa-circle-down-left',
  'fa-circle-down-right',
  'fa-circle-e',
  'fa-circle-ellipsis',
  'fa-circle-ellipsis-vertical',
  'fa-circle-envelope',
  'fa-envelope-circle',
  'fa-circle-exclamation',
  'fa-exclamation-circle',
  'fa-circle-exclamation-check',
  'fa-circle-f',
  'fa-circle-g',
  'fa-circle-h',
  'fa-hospital-symbol',
  'fa-circle-half',
  'fa-circle-half-stroke',
  'fa-adjust',
  'fa-circle-heart',
  'fa-heart-circle',
  'fa-circle-i',
  'fa-circle-info',
  'fa-info-circle',
  'fa-circle-j',
  'fa-circle-k',
  'fa-circle-l',
  'fa-circle-left',
  'fa-arrow-alt-circle-left',
  'fa-circle-location-arrow',
  'fa-location-circle',
  'fa-circle-m',
  'fa-circle-microphone',
  'fa-microphone-circle',
  'fa-circle-microphone-lines',
  'fa-microphone-circle-alt',
  'fa-circle-minus',
  'fa-minus-circle',
  'fa-circle-n',
  'fa-circle-notch',
  'fa-circle-o',
  'fa-circle-p',
  'fa-circle-parking',
  'fa-parking-circle',
  'fa-circle-pause',
  'fa-pause-circle',
  'fa-circle-phone',
  'fa-phone-circle',
  'fa-circle-phone-flip',
  'fa-phone-circle-alt',
  'fa-circle-phone-hangup',
  'fa-phone-circle-down',
  'fa-circle-play',
  'fa-play-circle',
  'fa-circle-plus',
  'fa-plus-circle',
  'fa-circle-q',
  'fa-circle-quarter',
  'fa-circle-quarters',
  'fa-circle-question',
  'fa-question-circle',
  'fa-circle-r',
  'fa-circle-radiation',
  'fa-radiation-alt',
  'fa-circle-right',
  'fa-arrow-alt-circle-right',
  'fa-circle-s',
  'fa-circle-small',
  'fa-circle-sort',
  'fa-sort-circle',
  'fa-circle-sort-down',
  'fa-sort-circle-down',
  'fa-circle-sort-up',
  'fa-sort-circle-up',
  'fa-circle-star',
  'fa-star-circle',
  'fa-circle-stop',
  'fa-stop-circle',
  'fa-circle-t',
  'fa-circle-three-quarters',
  'fa-circle-trash',
  'fa-trash-circle',
  'fa-circle-u',
  'fa-circle-up',
  'fa-arrow-alt-circle-up',
  'fa-circle-up-left',
  'fa-circle-up-right',
  'fa-circle-user',
  'fa-user-circle',
  'fa-circle-v',
  'fa-circle-video',
  'fa-video-circle',
  'fa-circle-w',
  'fa-circle-waveform-lines',
  'fa-waveform-circle',
  'fa-circle-x',
  'fa-circle-xmark',
  'fa-times-circle',
  'fa-xmark-circle',
  'fa-circle-y',
  'fa-circle-z',
  'fa-citrus',
  'fa-citrus-slice',
  'fa-city',
  'fa-clapperboard',
  'fa-clapperboard-play',
  'fa-clarinet',
  'fa-claw-marks',
  'fa-clipboard',
  'fa-clipboard-check',
  'fa-clipboard-list',
  'fa-clipboard-list-check',
  'fa-clipboard-medical',
  'fa-clipboard-prescription',
  'fa-clipboard-user',
  'fa-clock',
  'fa-clock-four',
  'fa-clock-desk',
  'fa-clock-eight',
  'fa-clock-eight-thirty',
  'fa-clock-eleven',
  'fa-clock-eleven-thirty',
  'fa-clock-five',
  'fa-clock-five-thirty',
  'fa-clock-four-thirty',
  'fa-clock-nine',
  'fa-clock-nine-thirty',
  'fa-clock-one',
  'fa-clock-one-thirty',
  'fa-clock-rotate-left',
  'fa-history',
  'fa-clock-seven',
  'fa-clock-seven-thirty',
  'fa-clock-six',
  'fa-clock-six-thirty',
  'fa-clock-ten',
  'fa-clock-ten-thirty',
  'fa-clock-three',
  'fa-clock-three-thirty',
  'fa-clock-twelve',
  'fa-clock-twelve-thirty',
  'fa-clock-two',
  'fa-clock-two-thirty',
  'fa-clone',
  'fa-closed-captioning',
  'fa-closed-captioning-slash',
  'fa-clothes-hanger',
  'fa-cloud',
  'fa-cloud-arrow-down',
  'fa-cloud-download',
  'fa-cloud-download-alt',
  'fa-cloud-arrow-up',
  'fa-cloud-upload',
  'fa-cloud-upload-alt',
  'fa-cloud-bolt',
  'fa-thunderstorm',
  'fa-cloud-bolt-moon',
  'fa-thunderstorm-moon',
  'fa-cloud-bolt-sun',
  'fa-thunderstorm-sun',
  'fa-cloud-check',
  'fa-cloud-drizzle',
  'fa-cloud-exclamation',
  'fa-cloud-fog',
  'fa-fog',
  'fa-cloud-hail',
  'fa-cloud-hail-mixed',
  'fa-cloud-meatball',
  'fa-cloud-minus',
  'fa-cloud-moon',
  'fa-cloud-moon-rain',
  'fa-cloud-music',
  'fa-cloud-plus',
  'fa-cloud-question',
  'fa-cloud-rain',
  'fa-cloud-rainbow',
  'fa-cloud-showers',
  'fa-cloud-showers-heavy',
  'fa-cloud-slash',
  'fa-cloud-sleet',
  'fa-cloud-snow',
  'fa-cloud-sun',
  'fa-cloud-sun-rain',
  'fa-cloud-word',
  'fa-cloud-xmark',
  'fa-clouds',
  'fa-clouds-moon',
  'fa-clouds-sun',
  'fa-clover',
  'fa-club',
  'fa-coconut',
  'fa-code',
  'fa-code-branch',
  'fa-code-commit',
  'fa-code-compare',
  'fa-code-fork',
  'fa-code-merge',
  'fa-code-pull-request',
  'fa-code-pull-request-closed',
  'fa-code-pull-request-draft',
  'fa-code-simple',
  'fa-coffee-bean',
  'fa-coffee-beans',
  'fa-coffee-pot',
  'fa-coffin',
  'fa-coffin-cross',
  'fa-coin',
  'fa-coin-blank',
  'fa-coin-front',
  'fa-coin-vertical',
  'fa-coins',
  'fa-colon',
  'fa-colon-sign',
  'fa-columns-3',
  'fa-comet',
  'fa-comma',
  'fa-command',
  'fa-comment',
  'fa-comment-arrow-down',
  'fa-comment-arrow-up',
  'fa-comment-arrow-up-right',
  'fa-comment-captions',
  'fa-comment-check',
  'fa-comment-code',
  'fa-comment-dollar',
  'fa-comment-dots',
  'fa-commenting',
  'fa-comment-exclamation',
  'fa-comment-image',
  'fa-comment-lines',
  'fa-comment-medical',
  'fa-comment-middle',
  'fa-comment-middle-top',
  'fa-comment-minus',
  'fa-comment-music',
  'fa-comment-pen',
  'fa-comment-edit',
  'fa-comment-plus',
  'fa-comment-question',
  'fa-comment-quote',
  'fa-comment-slash',
  'fa-comment-smile',
  'fa-comment-sms',
  'fa-sms',
  'fa-comment-text',
  'fa-comment-xmark',
  'fa-comment-times',
  'fa-comments',
  'fa-comments-dollar',
  'fa-comments-question',
  'fa-comments-question-check',
  'fa-compact-disc',
  'fa-compass',
  'fa-compass-drafting',
  'fa-drafting-compass',
  'fa-compass-slash',
  'fa-compress',
  'fa-compress-wide',
  'fa-computer-classic',
  'fa-computer-mouse',
  'fa-mouse',
  'fa-computer-mouse-scrollwheel',
  'fa-mouse-alt',
  'fa-computer-speaker',
  'fa-container-storage',
  'fa-conveyor-belt',
  'fa-conveyor-belt-boxes',
  'fa-conveyor-belt-alt',
  'fa-conveyor-belt-empty',
  'fa-cookie',
  'fa-cookie-bite',
  'fa-copy',
  'fa-copyright',
  'fa-corn',
  'fa-corner',
  'fa-couch',
  'fa-cow',
  'fa-cowbell',
  'fa-cowbell-circle-plus',
  'fa-cowbell-more',
  'fa-crab',
  'fa-crate-apple',
  'fa-apple-crate',
  'fa-crate-empty',
  'fa-credit-card',
  'fa-credit-card-alt',
  'fa-credit-card-blank',
  'fa-credit-card-front',
  'fa-cricket-bat-ball',
  'fa-cricket',
  'fa-croissant',
  'fa-crop',
  'fa-crop-simple',
  'fa-crop-alt',
  'fa-cross',
  'fa-crosshairs',
  'fa-crow',
  'fa-crown',
  'fa-crutch',
  'fa-crutches',
  'fa-cruzeiro-sign',
  'fa-crystal-ball',
  'fa-cube',
  'fa-cubes',
  'fa-cucumber',
  'fa-cup-straw',
  'fa-cup-straw-swoosh',
  'fa-cup-togo',
  'fa-coffee-togo',
  'fa-cupcake',
  'fa-curling-stone',
  'fa-curling',
  'fa-custard',
  'fa-d',
  'fa-dagger',
  'fa-dash',
  'fa-database',
  'fa-deer',
  'fa-deer-rudolph',
  'fa-delete-left',
  'fa-backspace',
  'fa-delete-right',
  'fa-democrat',
  'fa-desktop',
  'fa-desktop-alt',
  'fa-desktop-arrow-down',
  'fa-dharmachakra',
  'fa-diagram-cells',
  'fa-diagram-lean-canvas',
  'fa-diagram-nested',
  'fa-diagram-next',
  'fa-diagram-predecessor',
  'fa-diagram-previous',
  'fa-diagram-project',
  'fa-project-diagram',
  'fa-diagram-sankey',
  'fa-diagram-subtask',
  'fa-diagram-successor',
  'fa-diagram-venn',
  'fa-dial',
  'fa-dial-med-high',
  'fa-dial-high',
  'fa-dial-low',
  'fa-dial-max',
  'fa-dial-med',
  'fa-dial-med-low',
  'fa-dial-min',
  'fa-dial-off',
  'fa-diamond',
  'fa-diamond-exclamation',
  'fa-diamond-turn-right',
  'fa-directions',
  'fa-dice',
  'fa-dice-d10',
  'fa-dice-d12',
  'fa-dice-d20',
  'fa-dice-d4',
  'fa-dice-d6',
  'fa-dice-d8',
  'fa-dice-five',
  'fa-dice-four',
  'fa-dice-one',
  'fa-dice-six',
  'fa-dice-three',
  'fa-dice-two',
  'fa-diploma',
  'fa-scroll-ribbon',
  'fa-disc-drive',
  'fa-disease',
  'fa-display',
  'fa-display-arrow-down',
  'fa-display-code',
  'fa-desktop-code',
  'fa-display-medical',
  'fa-desktop-medical',
  'fa-display-slash',
  'fa-desktop-slash',
  'fa-distribute-spacing-horizontal',
  'fa-distribute-spacing-vertical',
  'fa-ditto',
  'fa-divide',
  'fa-dna',
  'fa-do-not-enter',
  'fa-dog',
  'fa-dog-leashed',
  'fa-dollar-sign',
  'fa-dollar',
  'fa-usd',
  'fa-dolly',
  'fa-dolly-box',
  'fa-dolly-empty',
  'fa-dolphin',
  'fa-dong-sign',
  'fa-donut',
  'fa-doughnut',
  'fa-door-closed',
  'fa-door-open',
  'fa-dove',
  'fa-down',
  'fa-arrow-alt-down',
  'fa-down-from-dotted-line',
  'fa-down-from-line',
  'fa-arrow-alt-from-top',
  'fa-down-left',
  'fa-down-left-and-up-right-to-center',
  'fa-compress-alt',
  'fa-down-long',
  'fa-long-arrow-alt-down',
  'fa-down-right',
  'fa-down-to-dotted-line',
  'fa-down-to-line',
  'fa-arrow-alt-to-bottom',
  'fa-download',
  'fa-dragon',
  'fa-draw-circle',
  'fa-draw-polygon',
  'fa-draw-square',
  'fa-dreidel',
  'fa-drone',
  'fa-drone-front',
  'fa-drone-alt',
  'fa-droplet',
  'fa-tint',
  'fa-droplet-degree',
  'fa-dewpoint',
  'fa-droplet-percent',
  'fa-humidity',
  'fa-droplet-slash',
  'fa-tint-slash',
  'fa-drum',
  'fa-drum-steelpan',
  'fa-drumstick',
  'fa-drumstick-bite',
  'fa-dryer',
  'fa-dryer-heat',
  'fa-dryer-alt',
  'fa-duck',
  'fa-dumbbell',
  'fa-dumpster',
  'fa-dumpster-fire',
  'fa-dungeon',
  'fa-e',
  'fa-ear',
  'fa-ear-deaf',
  'fa-deaf',
  'fa-deafness',
  'fa-hard-of-hearing',
  'fa-ear-listen',
  'fa-assistive-listening-systems',
  'fa-ear-muffs',
  'fa-earth-africa',
  'fa-globe-africa',
  'fa-earth-americas',
  'fa-earth',
  'fa-earth-america',
  'fa-globe-americas',
  'fa-earth-asia',
  'fa-globe-asia',
  'fa-earth-europe',
  'fa-globe-europe',
  'fa-earth-oceania',
  'fa-globe-oceania',
  'fa-eclipse',
  'fa-egg',
  'fa-egg-fried',
  'fa-eggplant',
  'fa-eject',
  'fa-elephant',
  'fa-elevator',
  'fa-ellipsis',
  'fa-ellipsis-h',
  'fa-ellipsis-stroke',
  'fa-ellipsis-h-alt',
  'fa-ellipsis-stroke-vertical',
  'fa-ellipsis-v-alt',
  'fa-ellipsis-vertical',
  'fa-ellipsis-v',
  'fa-empty-set',
  'fa-engine',
  'fa-engine-warning',
  'fa-engine-exclamation',
  'fa-envelope',
  'fa-envelope-dot',
  'fa-envelope-badge',
  'fa-envelope-open',
  'fa-envelope-open-dollar',
  'fa-envelope-open-text',
  'fa-envelopes',
  'fa-envelopes-bulk',
  'fa-mail-bulk',
  'fa-equals',
  'fa-eraser',
  'fa-escalator',
  'fa-ethernet',
  'fa-euro-sign',
  'fa-eur',
  'fa-euro',
  'fa-exclamation',
  'fa-expand',
  'fa-expand-wide',
  'fa-eye',
  'fa-eye-dropper',
  'fa-eye-dropper-empty',
  'fa-eyedropper',
  'fa-eye-dropper-full',
  'fa-eye-dropper-half',
  'fa-eye-evil',
  'fa-eye-low-vision',
  'fa-low-vision',
  'fa-eye-slash',
  'fa-eyes',
  'fa-f',
  'fa-face-angry',
  'fa-angry',
  'fa-face-angry-horns',
  'fa-face-anguished',
  'fa-face-anxious-sweat',
  'fa-face-astonished',
  'fa-face-awesome',
  'fa-gave-dandy',
  'fa-face-beam-hand-over-mouth',
  'fa-face-clouds',
  'fa-face-confounded',
  'fa-face-confused',
  'fa-face-cowboy-hat',
  'fa-face-diagonal-mouth',
  'fa-face-disappointed',
  'fa-face-disguise',
  'fa-face-dizzy',
  'fa-dizzy',
  'fa-face-dotted',
  'fa-face-downcast-sweat',
  'fa-face-drooling',
  'fa-face-exhaling',
  'fa-face-explode',
  'fa-exploding-head',
  'fa-face-expressionless',
  'fa-face-eyes-xmarks',
  'fa-face-fearful',
  'fa-face-flushed',
  'fa-flushed',
  'fa-face-frown',
  'fa-frown',
  'fa-face-frown-open',
  'fa-frown-open',
  'fa-face-frown-slight',
  'fa-face-glasses',
  'fa-face-grimace',
  'fa-grimace',
  'fa-face-grin',
  'fa-grin',
  'fa-face-grin-beam',
  'fa-grin-beam',
  'fa-face-grin-beam-sweat',
  'fa-grin-beam-sweat',
  'fa-face-grin-hearts',
  'fa-grin-hearts',
  'fa-face-grin-squint',
  'fa-grin-squint',
  'fa-face-grin-squint-tears',
  'fa-grin-squint-tears',
  'fa-face-grin-stars',
  'fa-grin-stars',
  'fa-face-grin-tears',
  'fa-grin-tears',
  'fa-face-grin-tongue',
  'fa-grin-tongue',
  'fa-face-grin-tongue-squint',
  'fa-grin-tongue-squint',
  'fa-face-grin-tongue-wink',
  'fa-grin-tongue-wink',
  'fa-face-grin-wide',
  'fa-grin-alt',
  'fa-face-grin-wink',
  'fa-grin-wink',
  'fa-face-hand-over-mouth',
  'fa-face-hand-peeking',
  'fa-face-hand-yawn',
  'fa-face-head-bandage',
  'fa-face-holding-back-tears',
  'fa-face-hushed',
  'fa-face-icicles',
  'fa-face-kiss',
  'fa-kiss',
  'fa-face-kiss-beam',
  'fa-kiss-beam',
  'fa-face-kiss-closed-eyes',
  'fa-face-kiss-wink-heart',
  'fa-kiss-wink-heart',
  'fa-face-laugh',
  'fa-laugh',
  'fa-face-laugh-beam',
  'fa-laugh-beam',
  'fa-face-laugh-squint',
  'fa-laugh-squint',
  'fa-face-laugh-wink',
  'fa-laugh-wink',
  'fa-face-lying',
  'fa-face-mask',
  'fa-face-meh',
  'fa-meh',
  'fa-face-meh-blank',
  'fa-meh-blank',
  'fa-face-melting',
  'fa-face-monocle',
  'fa-face-nauseated',
  'fa-face-nose-steam',
  'fa-face-party',
  'fa-face-pensive',
  'fa-face-persevering',
  'fa-face-pleading',
  'fa-face-pouting',
  'fa-face-raised-eyebrow',
  'fa-face-relieved',
  'fa-face-rolling-eyes',
  'fa-meh-rolling-eyes',
  'fa-face-sad-cry',
  'fa-sad-cry',
  'fa-face-sad-sweat',
  'fa-face-sad-tear',
  'fa-sad-tear',
  'fa-face-saluting',
  'fa-face-scream',
  'fa-face-shush',
  'fa-face-sleeping',
  'fa-face-sleepy',
  'fa-face-smile',
  'fa-smile',
  'fa-face-smile-beam',
  'fa-smile-beam',
  'fa-face-smile-halo',
  'fa-face-smile-hearts',
  'fa-face-smile-horns',
  'fa-face-smile-plus',
  'fa-smile-plus',
  'fa-face-smile-relaxed',
  'fa-face-smile-tear',
  'fa-face-smile-tongue',
  'fa-face-smile-upside-down',
  'fa-face-smile-wink',
  'fa-smile-wink',
  'fa-face-smiling-hands',
  'fa-face-smirking',
  'fa-face-spiral-eyes',
  'fa-face-sunglasses',
  'fa-face-surprise',
  'fa-surprise',
  'fa-face-swear',
  'fa-face-thermometer',
  'fa-face-thinking',
  'fa-face-tired',
  'fa-tired',
  'fa-face-tissue',
  'fa-face-tongue-money',
  'fa-face-tongue-sweat',
  'fa-face-unamused',
  'fa-face-viewfinder',
  'fa-face-vomit',
  'fa-face-weary',
  'fa-face-woozy',
  'fa-face-worried',
  'fa-face-zany',
  'fa-face-zipper',
  'fa-falafel',
  'fa-family',
  'fa-family-dress',
  'fa-family-pants',
  'fa-fan',
  'fa-fan-table',
  'fa-farm',
  'fa-barn-silo',
  'fa-faucet',
  'fa-faucet-drip',
  'fa-fax',
  'fa-feather',
  'fa-feather-pointed',
  'fa-feather-alt',
  'fa-fence',
  'fa-ferris-wheel',
  'fa-field-hockey-stick-ball',
  'fa-field-hockey',
  'fa-file',
  'fa-file-arrow-down',
  'fa-file-download',
  'fa-file-arrow-up',
  'fa-file-upload',
  'fa-file-audio',
  'fa-file-binary',
  'fa-file-certificate',
  'fa-file-award',
  'fa-file-chart-column',
  'fa-file-chart-line',
  'fa-file-chart-pie',
  'fa-file-check',
  'fa-file-circle-info',
  'fa-file-circle-plus',
  'fa-file-code',
  'fa-file-contract',
  'fa-file-csv',
  'fa-file-dashed-line',
  'fa-page-break',
  'fa-file-excel',
  'fa-file-exclamation',
  'fa-file-export',
  'fa-arrow-right-from-file',
  'fa-file-heart',
  'fa-file-image',
  'fa-file-import',
  'fa-arrow-right-to-file',
  'fa-file-invoice',
  'fa-file-invoice-dollar',
  'fa-file-lines',
  'fa-file-alt',
  'fa-file-text',
  'fa-file-lock',
  'fa-file-magnifying-glass',
  'fa-file-search',
  'fa-file-medical',
  'fa-file-minus',
  'fa-file-music',
  'fa-file-pdf',
  'fa-file-pen',
  'fa-file-edit',
  'fa-file-plus',
  'fa-file-plus-minus',
  'fa-file-powerpoint',
  'fa-file-prescription',
  'fa-file-signature',
  'fa-file-slash',
  'fa-file-spreadsheet',
  'fa-file-user',
  'fa-file-video',
  'fa-file-waveform',
  'fa-file-medical-alt',
  'fa-file-word',
  'fa-file-xmark',
  'fa-file-times',
  'fa-file-zipper',
  'fa-file-archive',
  'fa-files',
  'fa-files-medical',
  'fa-fill',
  'fa-fill-drip',
  'fa-film',
  'fa-film-canister',
  'fa-film-simple',
  'fa-film-alt',
  'fa-film-slash',
  'fa-films',
  'fa-filter',
  'fa-filter-circle-dollar',
  'fa-funnel-dollar',
  'fa-filter-circle-xmark',
  'fa-filter-list',
  'fa-filter-slash',
  'fa-filters',
  'fa-fingerprint',
  'fa-fire',
  'fa-fire-extinguisher',
  'fa-fire-flame',
  'fa-flame',
  'fa-fire-flame-curved',
  'fa-fire-alt',
  'fa-fire-flame-simple',
  'fa-burn',
  'fa-fire-hydrant',
  'fa-fire-smoke',
  'fa-fireplace',
  'fa-fish',
  'fa-fish-bones',
  'fa-fish-cooked',
  'fa-fishing-rod',
  'fa-flag',
  'fa-flag-checkered',
  'fa-flag-pennant',
  'fa-pennant',
  'fa-flag-swallowtail',
  'fa-flag-alt',
  'fa-flag-usa',
  'fa-flashlight',
  'fa-flask',
  'fa-flask-round-poison',
  'fa-flask-poison',
  'fa-flask-round-potion',
  'fa-flask-potion',
  'fa-flatbread',
  'fa-flatbread-stuffed',
  'fa-floppy-disk',
  'fa-save',
  'fa-floppy-disk-circle-arrow-right',
  'fa-save-circle-arrow-right',
  'fa-floppy-disk-circle-xmark',
  'fa-floppy-disk-times',
  'fa-save-circle-xmark',
  'fa-save-times',
  'fa-floppy-disk-pen',
  'fa-floppy-disks',
  'fa-florin-sign',
  'fa-flower',
  'fa-flower-daffodil',
  'fa-flower-tulip',
  'fa-flute',
  'fa-flux-capacitor',
  'fa-flying-disc',
  'fa-folder',
  'fa-folder-arrow-down',
  'fa-folder-download',
  'fa-folder-arrow-up',
  'fa-folder-upload',
  'fa-folder-blank',
  'fa-folder-bookmark',
  'fa-folder-gear',
  'fa-folder-cog',
  'fa-folder-grid',
  'fa-folder-heart',
  'fa-folder-image',
  'fa-folder-magnifying-glass',
  'fa-folder-search',
  'fa-folder-medical',
  'fa-folder-minus',
  'fa-folder-music',
  'fa-folder-open',
  'fa-folder-plus',
  'fa-folder-tree',
  'fa-folder-user',
  'fa-folder-xmark',
  'fa-folder-times',
  'fa-folders',
  'fa-fondue-pot',
  'fa-font',
  'fa-font-case',
  'fa-football',
  'fa-football-ball',
  'fa-football-helmet',
  'fa-fork',
  'fa-utensil-fork',
  'fa-fork-knife',
  'fa-utensils-alt',
  'fa-forklift',
  'fa-fort',
  'fa-forward',
  'fa-forward-fast',
  'fa-fast-forward',
  'fa-forward-step',
  'fa-step-forward',
  'fa-frame',
  'fa-franc-sign',
  'fa-french-fries',
  'fa-frog',
  'fa-function',
  'fa-futbol',
  'fa-futbol-ball',
  'fa-soccer-ball',
  'fa-g',
  'fa-galaxy',
  'fa-gallery-thumbnails',
  'fa-game-board',
  'fa-game-board-simple',
  'fa-game-board-alt',
  'fa-game-console-handheld',
  'fa-gamepad',
  'fa-gamepad-modern',
  'fa-gamepad-alt',
  'fa-garage',
  'fa-garage-car',
  'fa-garage-open',
  'fa-garlic',
  'fa-gas-pump',
  'fa-gas-pump-slash',
  'fa-gauge',
  'fa-dashboard',
  'fa-gauge-med',
  'fa-tachometer-alt-average',
  'fa-gauge-circle-bolt',
  'fa-gauge-circle-minus',
  'fa-gauge-circle-plus',
  'fa-gauge-high',
  'fa-tachometer-alt',
  'fa-tachometer-alt-fast',
  'fa-gauge-low',
  'fa-tachometer-alt-slow',
  'fa-gauge-max',
  'fa-tachometer-alt-fastest',
  'fa-gauge-min',
  'fa-tachometer-alt-slowest',
  'fa-gauge-simple',
  'fa-gauge-simple-med',
  'fa-tachometer-average',
  'fa-gauge-simple-high',
  'fa-tachometer',
  'fa-tachometer-fast',
  'fa-gauge-simple-low',
  'fa-tachometer-slow',
  'fa-gauge-simple-max',
  'fa-tachometer-fastest',
  'fa-gauge-simple-min',
  'fa-tachometer-slowest',
  'fa-gavel',
  'fa-legal',
  'fa-gear',
  'fa-cog',
  'fa-gears',
  'fa-cogs',
  'fa-gem',
  'fa-genderless',
  'fa-ghost',
  'fa-gif',
  'fa-gift',
  'fa-gift-card',
  'fa-gifts',
  'fa-gingerbread-man',
  'fa-glass',
  'fa-glass-citrus',
  'fa-glass-empty',
  'fa-glass-half',
  'fa-glass-half-empty',
  'fa-glass-half-full',
  'fa-glasses',
  'fa-glasses-round',
  'fa-glasses-alt',
  'fa-globe',
  'fa-globe-snow',
  'fa-globe-stand',
  'fa-goal-net',
  'fa-golf-ball-tee',
  'fa-golf-ball',
  'fa-golf-club',
  'fa-golf-flag-hole',
  'fa-gopuram',
  'fa-graduation-cap',
  'fa-mortar-board',
  'fa-gramophone',
  'fa-grapes',
  'fa-grate',
  'fa-grate-droplet',
  'fa-greater-than',
  'fa-greater-than-equal',
  'fa-grid',
  'fa-grid-3',
  'fa-grid-2',
  'fa-grid-2-plus',
  'fa-grid-4',
  'fa-grid-5',
  'fa-grid-dividers',
  'fa-grid-horizontal',
  'fa-grip',
  'fa-grip-horizontal',
  'fa-grip-dots',
  'fa-grip-dots-vertical',
  'fa-grip-lines',
  'fa-grip-lines-vertical',
  'fa-grip-vertical',
  'fa-guarani-sign',
  'fa-guitar',
  'fa-guitar-electric',
  'fa-guitars',
  'fa-gun',
  'fa-gun-slash',
  'fa-gun-squirt',
  'fa-h',
  'fa-h1',
  'fa-h2',
  'fa-h3',
  'fa-h4',
  'fa-h5',
  'fa-h6',
  'fa-hammer',
  'fa-hammer-crash',
  'fa-hammer-war',
  'fa-hamsa',
  'fa-hand',
  'fa-hand-paper',
  'fa-hand-back-fist',
  'fa-hand-rock',
  'fa-hand-back-point-down',
  'fa-hand-back-point-left',
  'fa-hand-back-point-ribbon',
  'fa-hand-back-point-right',
  'fa-hand-back-point-up',
  'fa-hand-dots',
  'fa-allergies',
  'fa-hand-fingers-crossed',
  'fa-hand-fist',
  'fa-fist-raised',
  'fa-hand-heart',
  'fa-hand-holding',
  'fa-hand-holding-box',
  'fa-hand-holding-dollar',
  'fa-hand-holding-usd',
  'fa-hand-holding-droplet',
  'fa-hand-holding-water',
  'fa-hand-holding-heart',
  'fa-hand-holding-magic',
  'fa-hand-holding-medical',
  'fa-hand-holding-seedling',
  'fa-hand-holding-skull',
  'fa-hand-horns',
  'fa-hand-lizard',
  'fa-hand-love',
  'fa-hand-middle-finger',
  'fa-hand-peace',
  'fa-hand-point-down',
  'fa-hand-point-left',
  'fa-hand-point-ribbon',
  'fa-hand-point-right',
  'fa-hand-point-up',
  'fa-hand-pointer',
  'fa-hand-scissors',
  'fa-hand-sparkles',
  'fa-hand-spock',
  'fa-hand-wave',
  'fa-hands',
  'fa-sign-language',
  'fa-signing',
  'fa-hands-asl-interpreting',
  'fa-american-sign-language-interpreting',
  'fa-asl-interpreting',
  'fa-hands-american-sign-language-interpreting',
  'fa-hands-bubbles',
  'fa-hands-wash',
  'fa-hands-clapping',
  'fa-hands-holding',
  'fa-hands-holding-diamond',
  'fa-hand-receiving',
  'fa-hands-holding-dollar',
  'fa-hands-usd',
  'fa-hands-holding-heart',
  'fa-hands-heart',
  'fa-hands-praying',
  'fa-praying-hands',
  'fa-handshake',
  'fa-handshake-angle',
  'fa-hands-helping',
  'fa-handshake-simple',
  'fa-handshake-alt',
  'fa-handshake-simple-slash',
  'fa-handshake-alt-slash',
  'fa-handshake-slash',
  'fa-hanukiah',
  'fa-hard-drive',
  'fa-hdd',
  'fa-hashtag',
  'fa-hashtag-lock',
  'fa-hat-chef',
  'fa-hat-cowboy',
  'fa-hat-cowboy-side',
  'fa-hat-santa',
  'fa-hat-winter',
  'fa-hat-witch',
  'fa-hat-wizard',
  'fa-head-side',
  'fa-head-side-brain',
  'fa-head-side-cough',
  'fa-head-side-cough-slash',
  'fa-head-side-goggles',
  'fa-head-vr',
  'fa-head-side-headphones',
  'fa-head-side-heart',
  'fa-head-side-mask',
  'fa-head-side-medical',
  'fa-head-side-virus',
  'fa-heading',
  'fa-header',
  'fa-headphones',
  'fa-headphones-simple',
  'fa-headphones-alt',
  'fa-headset',
  'fa-heart',
  'fa-heart-crack',
  'fa-heart-broken',
  'fa-heart-half',
  'fa-heart-half-stroke',
  'fa-heart-half-alt',
  'fa-heart-pulse',
  'fa-heartbeat',
  'fa-heat',
  'fa-helicopter',
  'fa-helmet-battle',
  'fa-helmet-safety',
  'fa-hard-hat',
  'fa-hat-hard',
  'fa-hexagon',
  'fa-hexagon-check',
  'fa-hexagon-divide',
  'fa-hexagon-exclamation',
  'fa-hexagon-minus',
  'fa-minus-hexagon',
  'fa-hexagon-plus',
  'fa-plus-hexagon',
  'fa-hexagon-xmark',
  'fa-times-hexagon',
  'fa-xmark-hexagon',
  'fa-high-definition',
  'fa-rectangle-hd',
  'fa-highlighter',
  'fa-highlighter-line',
  'fa-hippo',
  'fa-hockey-mask',
  'fa-hockey-puck',
  'fa-hockey-stick-puck',
  'fa-hockey-sticks',
  'fa-holly-berry',
  'fa-honey-pot',
  'fa-hood-cloak',
  'fa-horizontal-rule',
  'fa-horse',
  'fa-horse-head',
  'fa-horse-saddle',
  'fa-hose',
  'fa-hose-reel',
  'fa-hospital',
  'fa-hospital-alt',
  'fa-hospital-wide',
  'fa-hospital-user',
  'fa-hospitals',
  'fa-hot-tub-person',
  'fa-hot-tub',
  'fa-hotdog',
  'fa-hotel',
  'fa-hourglass',
  'fa-hourglass-2',
  'fa-hourglass-half',
  'fa-hourglass-clock',
  'fa-hourglass-empty',
  'fa-hourglass-end',
  'fa-hourglass-3',
  'fa-hourglass-start',
  'fa-hourglass-1',
  'fa-house',
  'fa-home',
  'fa-home-alt',
  'fa-home-lg-alt',
  'fa-house-blank',
  'fa-home-blank',
  'fa-house-building',
  'fa-house-chimney',
  'fa-home-lg',
  'fa-house-chimney-blank',
  'fa-house-chimney-crack',
  'fa-house-damage',
  'fa-house-chimney-heart',
  'fa-house-chimney-medical',
  'fa-clinic-medical',
  'fa-house-chimney-user',
  'fa-house-chimney-window',
  'fa-house-crack',
  'fa-house-day',
  'fa-house-flood',
  'fa-house-heart',
  'fa-home-heart',
  'fa-house-laptop',
  'fa-laptop-house',
  'fa-house-medical',
  'fa-house-night',
  'fa-house-person-leave',
  'fa-house-leave',
  'fa-house-person-depart',
  'fa-house-person-return',
  'fa-house-person-arrive',
  'fa-house-return',
  'fa-house-signal',
  'fa-house-tree',
  'fa-house-turret',
  'fa-house-user',
  'fa-home-user',
  'fa-house-window',
  'fa-hryvnia-sign',
  'fa-hryvnia',
  'fa-hundred-points',
  'fa-100',
  'fa-hurricane',
  'fa-hyphen',
  'fa-i',
  'fa-i-cursor',
  'fa-ice-cream',
  'fa-ice-skate',
  'fa-icicles',
  'fa-icons',
  'fa-heart-music-camera-bolt',
  'fa-id-badge',
  'fa-id-card',
  'fa-drivers-license',
  'fa-id-card-clip',
  'fa-id-card-alt',
  'fa-igloo',
  'fa-image',
  'fa-image-landscape',
  'fa-landscape',
  'fa-image-polaroid',
  'fa-image-polaroid-user',
  'fa-image-portrait',
  'fa-portrait',
  'fa-image-slash',
  'fa-image-user',
  'fa-images',
  'fa-images-user',
  'fa-inbox',
  'fa-inbox-full',
  'fa-inbox-in',
  'fa-inbox-arrow-down',
  'fa-inbox-out',
  'fa-inbox-arrow-up',
  'fa-inboxes',
  'fa-indent',
  'fa-indian-rupee-sign',
  'fa-indian-rupee',
  'fa-inr',
  'fa-industry',
  'fa-industry-windows',
  'fa-industry-alt',
  'fa-infinity',
  'fa-info',
  'fa-inhaler',
  'fa-input-numeric',
  'fa-input-pipe',
  'fa-input-text',
  'fa-integral',
  'fa-intersection',
  'fa-island-tropical',
  'fa-island-tree-palm',
  'fa-italic',
  'fa-j',
  'fa-jack-o-lantern',
  'fa-jedi',
  'fa-jet-fighter',
  'fa-fighter-jet',
  'fa-joint',
  'fa-joystick',
  'fa-jug',
  'fa-k',
  'fa-kaaba',
  'fa-kazoo',
  'fa-kerning',
  'fa-key',
  'fa-key-skeleton',
  'fa-key-skeleton-left-right',
  'fa-keyboard',
  'fa-keyboard-brightness',
  'fa-keyboard-brightness-low',
  'fa-keyboard-down',
  'fa-keyboard-left',
  'fa-keynote',
  'fa-khanda',
  'fa-kidneys',
  'fa-kip-sign',
  'fa-kit-medical',
  'fa-first-aid',
  'fa-kite',
  'fa-kiwi-bird',
  'fa-kiwi-fruit',
  'fa-knife',
  'fa-utensil-knife',
  'fa-knife-kitchen',
  'fa-l',
  'fa-lacrosse-stick',
  'fa-lacrosse-stick-ball',
  'fa-lambda',
  'fa-lamp',
  'fa-lamp-desk',
  'fa-lamp-floor',
  'fa-lamp-street',
  'fa-landmark',
  'fa-landmark-dome',
  'fa-landmark-alt',
  'fa-language',
  'fa-laptop',
  'fa-laptop-arrow-down',
  'fa-laptop-code',
  'fa-laptop-medical',
  'fa-laptop-mobile',
  'fa-phone-laptop',
  'fa-laptop-slash',
  'fa-lari-sign',
  'fa-lasso',
  'fa-lasso-sparkles',
  'fa-layer-group',
  'fa-layer-minus',
  'fa-layer-group-minus',
  'fa-layer-plus',
  'fa-layer-group-plus',
  'fa-leaf',
  'fa-leaf-heart',
  'fa-leaf-maple',
  'fa-leaf-oak',
  'fa-leafy-green',
  'fa-left',
  'fa-arrow-alt-left',
  'fa-left-from-line',
  'fa-arrow-alt-from-right',
  'fa-left-long',
  'fa-long-arrow-alt-left',
  'fa-left-long-to-line',
  'fa-left-right',
  'fa-arrows-alt-h',
  'fa-left-to-line',
  'fa-arrow-alt-to-left',
  'fa-lemon',
  'fa-less-than',
  'fa-less-than-equal',
  'fa-life-ring',
  'fa-light-ceiling',
  'fa-light-emergency',
  'fa-light-emergency-on',
  'fa-light-switch',
  'fa-light-switch-off',
  'fa-light-switch-on',
  'fa-lightbulb',
  'fa-lightbulb-dollar',
  'fa-lightbulb-exclamation',
  'fa-lightbulb-exclamation-on',
  'fa-lightbulb-on',
  'fa-lightbulb-slash',
  'fa-lights-holiday',
  'fa-line-columns',
  'fa-line-height',
  'fa-link',
  'fa-chain',
  'fa-link-horizontal',
  'fa-chain-horizontal',
  'fa-link-horizontal-slash',
  'fa-chain-horizontal-slash',
  'fa-link-simple',
  'fa-link-simple-slash',
  'fa-link-slash',
  'fa-chain-broken',
  'fa-chain-slash',
  'fa-unlink',
  'fa-lips',
  'fa-lira-sign',
  'fa-list',
  'fa-list-squares',
  'fa-list-check',
  'fa-tasks',
  'fa-list-dropdown',
  'fa-list-music',
  'fa-list-ol',
  'fa-list-1-2',
  'fa-list-numeric',
  'fa-list-radio',
  'fa-list-timeline',
  'fa-list-tree',
  'fa-list-ul',
  'fa-list-dots',
  'fa-litecoin-sign',
  'fa-loader',
  'fa-lobster',
  'fa-location-arrow',
  'fa-location-check',
  'fa-map-marker-check',
  'fa-location-crosshairs',
  'fa-location',
  'fa-location-crosshairs-slash',
  'fa-location-slash',
  'fa-location-dot',
  'fa-map-marker-alt',
  'fa-location-dot-slash',
  'fa-map-marker-alt-slash',
  'fa-location-exclamation',
  'fa-map-marker-exclamation',
  'fa-location-minus',
  'fa-map-marker-minus',
  'fa-location-pen',
  'fa-map-marker-edit',
  'fa-location-pin',
  'fa-map-marker',
  'fa-location-pin-slash',
  'fa-map-marker-slash',
  'fa-location-plus',
  'fa-map-marker-plus',
  'fa-location-question',
  'fa-map-marker-question',
  'fa-location-smile',
  'fa-map-marker-smile',
  'fa-location-xmark',
  'fa-map-marker-times',
  'fa-map-marker-xmark',
  'fa-lock',
  'fa-lock-a',
  'fa-lock-hashtag',
  'fa-lock-keyhole',
  'fa-lock-alt',
  'fa-lock-keyhole-open',
  'fa-lock-open-alt',
  'fa-lock-open',
  'fa-lollipop',
  'fa-lollypop',
  'fa-loveseat',
  'fa-couch-small',
  'fa-luchador-mask',
  'fa-luchador',
  'fa-mask-luchador',
  'fa-lungs',
  'fa-lungs-virus',
  'fa-m',
  'fa-mace',
  'fa-magnet',
  'fa-magnifying-glass',
  'fa-search',
  'fa-magnifying-glass-dollar',
  'fa-search-dollar',
  'fa-magnifying-glass-location',
  'fa-search-location',
  'fa-magnifying-glass-minus',
  'fa-search-minus',
  'fa-magnifying-glass-plus',
  'fa-search-plus',
  'fa-mailbox',
  'fa-manat-sign',
  'fa-mandolin',
  'fa-mango',
  'fa-manhole',
  'fa-map',
  'fa-map-location',
  'fa-map-marked',
  'fa-map-location-dot',
  'fa-map-marked-alt',
  'fa-map-pin',
  'fa-marker',
  'fa-mars',
  'fa-mars-and-venus',
  'fa-mars-double',
  'fa-mars-stroke',
  'fa-mars-stroke-right',
  'fa-mars-stroke-h',
  'fa-mars-stroke-up',
  'fa-mars-stroke-v',
  'fa-martini-glass',
  'fa-glass-martini-alt',
  'fa-martini-glass-citrus',
  'fa-cocktail',
  'fa-martini-glass-empty',
  'fa-glass-martini',
  'fa-mask',
  'fa-mask-face',
  'fa-mask-snorkel',
  'fa-masks-theater',
  'fa-theater-masks',
  'fa-maximize',
  'fa-expand-arrows-alt',
  'fa-meat',
  'fa-medal',
  'fa-megaphone',
  'fa-melon',
  'fa-melon-slice',
  'fa-memo',
  'fa-memo-circle-check',
  'fa-memo-circle-info',
  'fa-memo-pad',
  'fa-memory',
  'fa-menorah',
  'fa-mercury',
  'fa-message',
  'fa-comment-alt',
  'fa-message-arrow-down',
  'fa-comment-alt-arrow-down',
  'fa-message-arrow-up',
  'fa-comment-alt-arrow-up',
  'fa-message-arrow-up-right',
  'fa-message-bot',
  'fa-message-captions',
  'fa-comment-alt-captions',
  'fa-message-check',
  'fa-comment-alt-check',
  'fa-message-code',
  'fa-message-dollar',
  'fa-comment-alt-dollar',
  'fa-message-dots',
  'fa-comment-alt-dots',
  'fa-messaging',
  'fa-message-exclamation',
  'fa-comment-alt-exclamation',
  'fa-message-image',
  'fa-comment-alt-image',
  'fa-message-lines',
  'fa-comment-alt-lines',
  'fa-message-medical',
  'fa-comment-alt-medical',
  'fa-message-middle',
  'fa-comment-middle-alt',
  'fa-message-middle-top',
  'fa-comment-middle-top-alt',
  'fa-message-minus',
  'fa-comment-alt-minus',
  'fa-message-music',
  'fa-comment-alt-music',
  'fa-message-pen',
  'fa-comment-alt-edit',
  'fa-message-edit',
  'fa-message-plus',
  'fa-comment-alt-plus',
  'fa-message-question',
  'fa-message-quote',
  'fa-comment-alt-quote',
  'fa-message-slash',
  'fa-comment-alt-slash',
  'fa-message-smile',
  'fa-comment-alt-smile',
  'fa-message-sms',
  'fa-message-text',
  'fa-comment-alt-text',
  'fa-message-xmark',
  'fa-comment-alt-times',
  'fa-message-times',
  'fa-messages',
  'fa-comments-alt',
  'fa-messages-dollar',
  'fa-comments-alt-dollar',
  'fa-messages-question',
  'fa-meteor',
  'fa-meter',
  'fa-meter-bolt',
  'fa-meter-droplet',
  'fa-meter-fire',
  'fa-microchip',
  'fa-microchip-ai',
  'fa-microphone',
  'fa-microphone-lines',
  'fa-microphone-alt',
  'fa-microphone-lines-slash',
  'fa-microphone-alt-slash',
  'fa-microphone-slash',
  'fa-microphone-stand',
  'fa-microscope',
  'fa-microwave',
  'fa-mill-sign',
  'fa-minimize',
  'fa-compress-arrows-alt',
  'fa-minus',
  'fa-subtract',
  'fa-mistletoe',
  'fa-mitten',
  'fa-mobile',
  'fa-mobile-android',
  'fa-mobile-phone',
  'fa-mobile-button',
  'fa-mobile-notch',
  'fa-mobile-iphone',
  'fa-mobile-screen',
  'fa-mobile-android-alt',
  'fa-mobile-screen-button',
  'fa-mobile-alt',
  'fa-mobile-signal',
  'fa-mobile-signal-out',
  'fa-money-bill',
  'fa-money-bill-1',
  'fa-money-bill-alt',
  'fa-money-bill-1-wave',
  'fa-money-bill-wave-alt',
  'fa-money-bill-simple',
  'fa-money-bill-simple-wave',
  'fa-money-bill-wave',
  'fa-money-bills',
  'fa-money-bills-simple',
  'fa-money-bills-alt',
  'fa-money-check',
  'fa-money-check-dollar',
  'fa-money-check-alt',
  'fa-money-check-dollar-pen',
  'fa-money-check-edit-alt',
  'fa-money-check-pen',
  'fa-money-check-edit',
  'fa-money-from-bracket',
  'fa-money-simple-from-bracket',
  'fa-monitor-waveform',
  'fa-monitor-heart-rate',
  'fa-monkey',
  'fa-monument',
  'fa-moon',
  'fa-moon-cloud',
  'fa-moon-over-sun',
  'fa-eclipse-alt',
  'fa-moon-stars',
  'fa-moped',
  'fa-mortar-pestle',
  'fa-mosque',
  'fa-motorcycle',
  'fa-mountain',
  'fa-mountains',
  'fa-mp3-player',
  'fa-mug',
  'fa-mug-hot',
  'fa-mug-marshmallows',
  'fa-mug-saucer',
  'fa-coffee',
  'fa-mug-tea',
  'fa-mug-tea-saucer',
  'fa-mushroom',
  'fa-music',
  'fa-music-note',
  'fa-music-alt',
  'fa-music-note-slash',
  'fa-music-alt-slash',
  'fa-music-slash',
  'fa-n',
  'fa-naira-sign',
  'fa-narwhal',
  'fa-nesting-dolls',
  'fa-network-wired',
  'fa-neuter',
  'fa-newspaper',
  'fa-nfc',
  'fa-nfc-lock',
  'fa-nfc-magnifying-glass',
  'fa-nfc-pen',
  'fa-nfc-signal',
  'fa-nfc-slash',
  'fa-nfc-trash',
  'fa-not-equal',
  'fa-notdef',
  'fa-note',
  'fa-note-medical',
  'fa-note-sticky',
  'fa-sticky-note',
  'fa-notebook',
  'fa-notes',
  'fa-notes-medical',
  'fa-o',
  'fa-object-exclude',
  'fa-object-group',
  'fa-object-intersect',
  'fa-object-subtract',
  'fa-object-ungroup',
  'fa-object-union',
  'fa-objects-align-bottom',
  'fa-objects-align-center-horizontal',
  'fa-objects-align-center-vertical',
  'fa-objects-align-left',
  'fa-objects-align-right',
  'fa-objects-align-top',
  'fa-objects-column',
  'fa-octagon',
  'fa-octagon-check',
  'fa-octagon-divide',
  'fa-octagon-exclamation',
  'fa-octagon-minus',
  'fa-minus-octagon',
  'fa-octagon-plus',
  'fa-plus-octagon',
  'fa-octagon-xmark',
  'fa-times-octagon',
  'fa-xmark-octagon',
  'fa-oil-can',
  'fa-oil-can-drip',
  'fa-oil-temperature',
  'fa-oil-temp',
  'fa-olive',
  'fa-olive-branch',
  'fa-om',
  'fa-omega',
  'fa-onion',
  'fa-option',
  'fa-ornament',
  'fa-otter',
  'fa-outdent',
  'fa-dedent',
  'fa-outlet',
  'fa-oven',
  'fa-overline',
  'fa-p',
  'fa-page',
  'fa-page-caret-down',
  'fa-file-caret-down',
  'fa-page-caret-up',
  'fa-file-caret-up',
  'fa-pager',
  'fa-paint-roller',
  'fa-paintbrush',
  'fa-paint-brush',
  'fa-paintbrush-fine',
  'fa-paint-brush-alt',
  'fa-paint-brush-fine',
  'fa-paintbrush-alt',
  'fa-paintbrush-pencil',
  'fa-palette',
  'fa-pallet',
  'fa-pallet-box',
  'fa-pallet-boxes',
  'fa-palette-boxes',
  'fa-pallet-alt',
  'fa-pan-food',
  'fa-pan-frying',
  'fa-pancakes',
  'fa-panel-ews',
  'fa-panel-fire',
  'fa-panorama',
  'fa-paper-plane',
  'fa-paper-plane-top',
  'fa-paper-plane-alt',
  'fa-send',
  'fa-paperclip',
  'fa-paperclip-vertical',
  'fa-parachute-box',
  'fa-paragraph',
  'fa-paragraph-left',
  'fa-paragraph-rtl',
  'fa-party-bell',
  'fa-party-horn',
  'fa-passport',
  'fa-paste',
  'fa-file-clipboard',
  'fa-pause',
  'fa-paw',
  'fa-paw-claws',
  'fa-paw-simple',
  'fa-paw-alt',
  'fa-peace',
  'fa-peach',
  'fa-peanut',
  'fa-peanuts',
  'fa-peapod',
  'fa-pear',
  'fa-pedestal',
  'fa-pegasus',
  'fa-pen',
  'fa-pen-circle',
  'fa-pen-clip',
  'fa-pen-alt',
  'fa-pen-clip-slash',
  'fa-pen-alt-slash',
  'fa-pen-fancy',
  'fa-pen-fancy-slash',
  'fa-pen-field',
  'fa-pen-line',
  'fa-pen-nib',
  'fa-pen-nib-slash',
  'fa-pen-paintbrush',
  'fa-pencil-paintbrush',
  'fa-pen-ruler',
  'fa-pencil-ruler',
  'fa-pen-slash',
  'fa-pen-swirl',
  'fa-pen-to-square',
  'fa-edit',
  'fa-pencil',
  'fa-pencil-alt',
  'fa-pencil-slash',
  'fa-people',
  'fa-people-arrows-left-right',
  'fa-people-arrows',
  'fa-people-carry-box',
  'fa-people-carry',
  'fa-people-dress',
  'fa-people-dress-simple',
  'fa-people-pants',
  'fa-people-pants-simple',
  'fa-people-simple',
  'fa-pepper',
  'fa-pepper-hot',
  'fa-percent',
  'fa-percentage',
  'fa-period',
  'fa-person',
  'fa-male',
  'fa-person-biking',
  'fa-biking',
  'fa-person-biking-mountain',
  'fa-biking-mountain',
  'fa-person-booth',
  'fa-person-carry-box',
  'fa-person-carry',
  'fa-person-digging',
  'fa-digging',
  'fa-person-dolly',
  'fa-person-dolly-empty',
  'fa-person-dots-from-line',
  'fa-diagnoses',
  'fa-person-dress',
  'fa-female',
  'fa-person-dress-simple',
  'fa-person-from-portal',
  'fa-portal-exit',
  'fa-person-hiking',
  'fa-hiking',
  'fa-person-pinball',
  'fa-person-praying',
  'fa-pray',
  'fa-person-pregnant',
  'fa-person-running',
  'fa-running',
  'fa-person-seat',
  'fa-person-seat-reclined',
  'fa-person-sign',
  'fa-person-simple',
  'fa-person-skating',
  'fa-skating',
  'fa-person-ski-jumping',
  'fa-ski-jump',
  'fa-person-ski-lift',
  'fa-ski-lift',
  'fa-person-skiing',
  'fa-skiing',
  'fa-person-skiing-nordic',
  'fa-skiing-nordic',
  'fa-person-sledding',
  'fa-sledding',
  'fa-person-snowboarding',
  'fa-snowboarding',
  'fa-person-snowmobiling',
  'fa-snowmobile',
  'fa-person-swimming',
  'fa-swimmer',
  'fa-person-to-door',
  'fa-person-to-portal',
  'fa-portal-enter',
  'fa-person-walking',
  'fa-walking',
  'fa-person-walking-with-cane',
  'fa-blind',
  'fa-peseta-sign',
  'fa-peso-sign',
  'fa-phone',
  'fa-phone-arrow-down-left',
  'fa-phone-arrow-down',
  'fa-phone-incoming',
  'fa-phone-arrow-up-right',
  'fa-phone-arrow-up',
  'fa-phone-outgoing',
  'fa-phone-flip',
  'fa-phone-alt',
  'fa-phone-hangup',
  'fa-phone-intercom',
  'fa-phone-missed',
  'fa-phone-office',
  'fa-phone-plus',
  'fa-phone-rotary',
  'fa-phone-slash',
  'fa-phone-volume',
  'fa-volume-control-phone',
  'fa-phone-xmark',
  'fa-photo-film',
  'fa-photo-video',
  'fa-photo-film-music',
  'fa-pi',
  'fa-piano',
  'fa-piano-keyboard',
  'fa-pickleball',
  'fa-pie',
  'fa-pig',
  'fa-piggy-bank',
  'fa-pills',
  'fa-pinata',
  'fa-pinball',
  'fa-pineapple',
  'fa-pipe',
  'fa-pipe-circle-check',
  'fa-pipe-collar',
  'fa-pipe-section',
  'fa-pipe-smoking',
  'fa-pipe-valve',
  'fa-pizza',
  'fa-pizza-slice',
  'fa-place-of-worship',
  'fa-plane',
  'fa-plane-arrival',
  'fa-plane-departure',
  'fa-plane-engines',
  'fa-plane-alt',
  'fa-plane-prop',
  'fa-plane-slash',
  'fa-plane-tail',
  'fa-plane-up',
  'fa-plane-up-slash',
  'fa-planet-moon',
  'fa-planet-ringed',
  'fa-plate-utensils',
  'fa-play',
  'fa-play-pause',
  'fa-plug',
  'fa-plus',
  'fa-add',
  'fa-plus-minus',
  'fa-podcast',
  'fa-podium',
  'fa-podium-star',
  'fa-police-box',
  'fa-poll-people',
  'fa-pompebled',
  'fa-poo',
  'fa-poo-storm',
  'fa-poo-bolt',
  'fa-pool-8-ball',
  'fa-poop',
  'fa-popcorn',
  'fa-popsicle',
  'fa-pot-food',
  'fa-potato',
  'fa-power-off',
  'fa-prescription',
  'fa-prescription-bottle',
  'fa-prescription-bottle-medical',
  'fa-prescription-bottle-alt',
  'fa-presentation-screen',
  'fa-presentation',
  'fa-pretzel',
  'fa-print',
  'fa-print-magnifying-glass',
  'fa-print-search',
  'fa-print-slash',
  'fa-projector',
  'fa-pump',
  'fa-pump-medical',
  'fa-pump-soap',
  'fa-pumpkin',
  'fa-puzzle',
  'fa-puzzle-piece',
  'fa-puzzle-piece-simple',
  'fa-puzzle-piece-alt',
  'fa-q',
  'fa-qrcode',
  'fa-question',
  'fa-quote-left',
  'fa-quote-left-alt',
  'fa-quote-right',
  'fa-quote-right-alt',
  'fa-quotes',
  'fa-r',
  'fa-rabbit',
  'fa-rabbit-running',
  'fa-rabbit-fast',
  'fa-racquet',
  'fa-radar',
  'fa-radiation',
  'fa-radio',
  'fa-radio-tuner',
  'fa-radio-alt',
  'fa-rainbow',
  'fa-raindrops',
  'fa-ram',
  'fa-ramp-loading',
  'fa-raygun',
  'fa-receipt',
  'fa-record-vinyl',
  'fa-rectangle',
  'fa-rectangle-landscape',
  'fa-rectangle-ad',
  'fa-ad',
  'fa-rectangle-barcode',
  'fa-barcode-alt',
  'fa-rectangle-code',
  'fa-rectangle-history',
  'fa-rectangle-history-circle-plus',
  'fa-rectangle-history-circle-user',
  'fa-rectangle-list',
  'fa-list-alt',
  'fa-rectangle-pro',
  'fa-pro',
  'fa-rectangle-terminal',
  'fa-rectangle-vertical',
  'fa-rectangle-portrait',
  'fa-rectangle-vertical-history',
  'fa-rectangle-wide',
  'fa-rectangle-xmark',
  'fa-rectangle-times',
  'fa-times-rectangle',
  'fa-window-close',
  'fa-rectangles-mixed',
  'fa-recycle',
  'fa-reel',
  'fa-refrigerator',
  'fa-registered',
  'fa-repeat',
  'fa-repeat-1',
  'fa-reply',
  'fa-mail-reply',
  'fa-reply-all',
  'fa-mail-reply-all',
  'fa-reply-clock',
  'fa-reply-time',
  'fa-republican',
  'fa-restroom',
  'fa-restroom-simple',
  'fa-retweet',
  'fa-rhombus',
  'fa-ribbon',
  'fa-right',
  'fa-arrow-alt-right',
  'fa-right-from-bracket',
  'fa-sign-out-alt',
  'fa-right-from-line',
  'fa-arrow-alt-from-left',
  'fa-right-left',
  'fa-exchange-alt',
  'fa-right-long',
  'fa-long-arrow-alt-right',
  'fa-right-long-to-line',
  'fa-right-to-bracket',
  'fa-sign-in-alt',
  'fa-right-to-line',
  'fa-arrow-alt-to-right',
  'fa-ring',
  'fa-rings-wedding',
  'fa-road',
  'fa-robot',
  'fa-robot-astromech',
  'fa-rocket',
  'fa-rocket-launch',
  'fa-roller-coaster',
  'fa-rotate',
  'fa-sync-alt',
  'fa-rotate-exclamation',
  'fa-rotate-left',
  'fa-rotate-back',
  'fa-rotate-backward',
  'fa-undo-alt',
  'fa-rotate-right',
  'fa-redo-alt',
  'fa-rotate-forward',
  'fa-route',
  'fa-route-highway',
  'fa-route-interstate',
  'fa-router',
  'fa-rss',
  'fa-feed',
  'fa-ruble-sign',
  'fa-rouble',
  'fa-rub',
  'fa-ruble',
  'fa-rugby-ball',
  'fa-ruler',
  'fa-ruler-combined',
  'fa-ruler-horizontal',
  'fa-ruler-triangle',
  'fa-ruler-vertical',
  'fa-rupee-sign',
  'fa-rupee',
  'fa-rupiah-sign',
  'fa-rv',
  'fa-s',
  'fa-sack',
  'fa-sack-dollar',
  'fa-sailboat',
  'fa-salad',
  'fa-bowl-salad',
  'fa-salt-shaker',
  'fa-sandwich',
  'fa-satellite',
  'fa-satellite-dish',
  'fa-sausage',
  'fa-saxophone',
  'fa-saxophone-fire',
  'fa-sax-hot',
  'fa-scale-balanced',
  'fa-balance-scale',
  'fa-scale-unbalanced',
  'fa-balance-scale-left',
  'fa-scale-unbalanced-flip',
  'fa-balance-scale-right',
  'fa-scalpel',
  'fa-scalpel-line-dashed',
  'fa-scalpel-path',
  'fa-scanner',
  'fa-scanner-image',
  'fa-scanner-gun',
  'fa-scanner-keyboard',
  'fa-scanner-touchscreen',
  'fa-scarecrow',
  'fa-scarf',
  'fa-school',
  'fa-scissors',
  'fa-cut',
  'fa-screen-users',
  'fa-users-class',
  'fa-screencast',
  'fa-screwdriver',
  'fa-screwdriver-wrench',
  'fa-tools',
  'fa-scribble',
  'fa-scroll',
  'fa-scroll-old',
  'fa-scroll-torah',
  'fa-torah',
  'fa-scrubber',
  'fa-scythe',
  'fa-sd-card',
  'fa-sd-cards',
  'fa-seal',
  'fa-seal-exclamation',
  'fa-seal-question',
  'fa-seat-airline',
  'fa-section',
  'fa-seedling',
  'fa-sprout',
  'fa-semicolon',
  'fa-send-back',
  'fa-send-backward',
  'fa-sensor',
  'fa-sensor-cloud',
  'fa-sensor-smoke',
  'fa-sensor-fire',
  'fa-sensor-on',
  'fa-sensor-triangle-exclamation',
  'fa-sensor-alert',
  'fa-server',
  'fa-shapes',
  'fa-triangle-circle-square',
  'fa-share',
  'fa-arrow-turn-right',
  'fa-mail-forward',
  'fa-share-all',
  'fa-arrows-turn-right',
  'fa-share-from-square',
  'fa-share-square',
  'fa-share-nodes',
  'fa-share-alt',
  'fa-sheep',
  'fa-shekel-sign',
  'fa-ils',
  'fa-shekel',
  'fa-sheqel',
  'fa-sheqel-sign',
  'fa-shelves',
  'fa-inventory',
  'fa-shelves-empty',
  'fa-shield',
  'fa-shield-blank',
  'fa-shield-alt',
  'fa-shield-check',
  'fa-shield-cross',
  'fa-shield-exclamation',
  'fa-shield-keyhole',
  'fa-shield-minus',
  'fa-shield-plus',
  'fa-shield-slash',
  'fa-shield-virus',
  'fa-shield-xmark',
  'fa-shield-times',
  'fa-ship',
  'fa-shirt',
  'fa-t-shirt',
  'fa-tshirt',
  'fa-shirt-long-sleeve',
  'fa-shirt-running',
  'fa-shirt-tank-top',
  'fa-shish-kebab',
  'fa-shoe-prints',
  'fa-shop',
  'fa-store-alt',
  'fa-shop-lock',
  'fa-shop-slash',
  'fa-store-alt-slash',
  'fa-shovel',
  'fa-shovel-snow',
  'fa-shower',
  'fa-shower-down',
  'fa-shower-alt',
  'fa-shredder',
  'fa-shrimp',
  'fa-shuffle',
  'fa-random',
  'fa-shutters',
  'fa-shuttle-space',
  'fa-space-shuttle',
  'fa-shuttlecock',
  'fa-sickle',
  'fa-sidebar',
  'fa-sidebar-flip',
  'fa-sigma',
  'fa-sign-hanging',
  'fa-sign',
  'fa-signal',
  'fa-signal-5',
  'fa-signal-perfect',
  'fa-signal-bars',
  'fa-signal-alt',
  'fa-signal-alt-4',
  'fa-signal-bars-strong',
  'fa-signal-bars-fair',
  'fa-signal-alt-2',
  'fa-signal-bars-good',
  'fa-signal-alt-3',
  'fa-signal-bars-slash',
  'fa-signal-alt-slash',
  'fa-signal-bars-weak',
  'fa-signal-alt-1',
  'fa-signal-fair',
  'fa-signal-2',
  'fa-signal-good',
  'fa-signal-3',
  'fa-signal-slash',
  'fa-signal-stream',
  'fa-signal-stream-slash',
  'fa-signal-strong',
  'fa-signal-4',
  'fa-signal-weak',
  'fa-signal-1',
  'fa-signature',
  'fa-signature-lock',
  'fa-signature-slash',
  'fa-signs-post',
  'fa-map-signs',
  'fa-sim-card',
  'fa-sim-cards',
  'fa-sink',
  'fa-siren',
  'fa-siren-on',
  'fa-sitemap',
  'fa-skeleton',
  'fa-ski-boot',
  'fa-ski-boot-ski',
  'fa-skull',
  'fa-skull-cow',
  'fa-skull-crossbones',
  'fa-slash',
  'fa-slash-back',
  'fa-slash-forward',
  'fa-sleigh',
  'fa-slider',
  'fa-sliders',
  'fa-sliders-h',
  'fa-sliders-simple',
  'fa-sliders-up',
  'fa-sliders-v',
  'fa-slot-machine',
  'fa-smog',
  'fa-smoke',
  'fa-smoking',
  'fa-snake',
  'fa-snooze',
  'fa-zzz',
  'fa-snow-blowing',
  'fa-snowflake',
  'fa-snowflakes',
  'fa-snowman',
  'fa-snowman-head',
  'fa-frosty-head',
  'fa-snowplow',
  'fa-soap',
  'fa-socks',
  'fa-soft-serve',
  'fa-creemee',
  'fa-solar-panel',
  'fa-solar-system',
  'fa-sort',
  'fa-unsorted',
  'fa-sort-down',
  'fa-sort-desc',
  'fa-sort-up',
  'fa-sort-asc',
  'fa-spa',
  'fa-space-station-moon',
  'fa-space-station-moon-construction',
  'fa-space-station-moon-alt',
  'fa-spade',
  'fa-spaghetti-monster-flying',
  'fa-pastafarianism',
  'fa-sparkles',
  'fa-speaker',
  'fa-speakers',
  'fa-spell-check',
  'fa-spider',
  'fa-spider-black-widow',
  'fa-spider-web',
  'fa-spinner',
  'fa-spinner-third',
  'fa-split',
  'fa-splotch',
  'fa-spoon',
  'fa-utensil-spoon',
  'fa-sportsball',
  'fa-spray-can',
  'fa-spray-can-sparkles',
  'fa-air-freshener',
  'fa-sprinkler',
  'fa-sprinkler-ceiling',
  'fa-square',
  'fa-square-0',
  'fa-square-1',
  'fa-square-2',
  'fa-square-3',
  'fa-square-4',
  'fa-square-5',
  'fa-square-6',
  'fa-square-7',
  'fa-square-8',
  'fa-square-9',
  'fa-square-a',
  'fa-square-a-lock',
  'fa-square-ampersand',
  'fa-square-arrow-down',
  'fa-arrow-square-down',
  'fa-square-arrow-down-left',
  'fa-square-arrow-down-right',
  'fa-square-arrow-left',
  'fa-arrow-square-left',
  'fa-square-arrow-right',
  'fa-arrow-square-right',
  'fa-square-arrow-up',
  'fa-arrow-square-up',
  'fa-square-arrow-up-left',
  'fa-square-arrow-up-right',
  'fa-external-link-square',
  'fa-square-b',
  'fa-square-bolt',
  'fa-square-c',
  'fa-square-caret-down',
  'fa-caret-square-down',
  'fa-square-caret-left',
  'fa-caret-square-left',
  'fa-square-caret-right',
  'fa-caret-square-right',
  'fa-square-caret-up',
  'fa-caret-square-up',
  'fa-square-check',
  'fa-check-square',
  'fa-square-chevron-down',
  'fa-chevron-square-down',
  'fa-square-chevron-left',
  'fa-chevron-square-left',
  'fa-square-chevron-right',
  'fa-chevron-square-right',
  'fa-square-chevron-up',
  'fa-chevron-square-up',
  'fa-square-code',
  'fa-square-d',
  'fa-square-dashed',
  'fa-square-divide',
  'fa-square-dollar',
  'fa-dollar-square',
  'fa-usd-square',
  'fa-square-down',
  'fa-arrow-alt-square-down',
  'fa-square-down-left',
  'fa-square-down-right',
  'fa-square-e',
  'fa-square-ellipsis',
  'fa-square-ellipsis-vertical',
  'fa-square-envelope',
  'fa-envelope-square',
  'fa-square-exclamation',
  'fa-exclamation-square',
  'fa-square-f',
  'fa-square-fragile',
  'fa-box-fragile',
  'fa-square-wine-glass-crack',
  'fa-square-full',
  'fa-square-g',
  'fa-square-h',
  'fa-h-square',
  'fa-square-heart',
  'fa-heart-square',
  'fa-square-i',
  'fa-square-info',
  'fa-info-square',
  'fa-square-j',
  'fa-square-k',
  'fa-square-kanban',
  'fa-square-l',
  'fa-square-left',
  'fa-arrow-alt-square-left',
  'fa-square-list',
  'fa-square-m',
  'fa-square-minus',
  'fa-minus-square',
  'fa-square-n',
  'fa-square-o',
  'fa-square-p',
  'fa-square-parking',
  'fa-parking',
  'fa-square-parking-slash',
  'fa-parking-slash',
  'fa-square-pen',
  'fa-pen-square',
  'fa-pencil-square',
  'fa-square-phone',
  'fa-phone-square',
  'fa-square-phone-flip',
  'fa-phone-square-alt',
  'fa-square-phone-hangup',
  'fa-phone-square-down',
  'fa-square-plus',
  'fa-plus-square',
  'fa-square-poll-horizontal',
  'fa-poll-h',
  'fa-square-poll-vertical',
  'fa-poll',
  'fa-square-q',
  'fa-square-quarters',
  'fa-square-question',
  'fa-question-square',
  'fa-square-quote',
  'fa-square-r',
  'fa-square-right',
  'fa-arrow-alt-square-right',
  'fa-square-ring',
  'fa-square-root',
  'fa-square-root-variable',
  'fa-square-root-alt',
  'fa-square-rss',
  'fa-rss-square',
  'fa-square-s',
  'fa-square-share-nodes',
  'fa-share-alt-square',
  'fa-square-sliders',
  'fa-sliders-h-square',
  'fa-square-sliders-vertical',
  'fa-sliders-v-square',
  'fa-square-small',
  'fa-square-star',
  'fa-square-t',
  'fa-square-terminal',
  'fa-square-this-way-up',
  'fa-box-up',
  'fa-square-u',
  'fa-square-up',
  'fa-arrow-alt-square-up',
  'fa-square-up-left',
  'fa-square-up-right',
  'fa-external-link-square-alt',
  'fa-square-user',
  'fa-square-v',
  'fa-square-w',
  'fa-square-x',
  'fa-square-xmark',
  'fa-times-square',
  'fa-xmark-square',
  'fa-square-y',
  'fa-square-z',
  'fa-squid',
  'fa-squirrel',
  'fa-staff',
  'fa-stairs',
  'fa-stamp',
  'fa-standard-definition',
  'fa-rectangle-sd',
  'fa-star',
  'fa-star-and-crescent',
  'fa-star-christmas',
  'fa-star-exclamation',
  'fa-star-half',
  'fa-star-half-stroke',
  'fa-star-half-alt',
  'fa-star-of-david',
  'fa-star-of-life',
  'fa-star-sharp',
  'fa-star-sharp-half',
  'fa-star-sharp-half-stroke',
  'fa-star-sharp-half-alt',
  'fa-star-shooting',
  'fa-starfighter',
  'fa-starfighter-twin-ion-engine',
  'fa-starfighter-alt',
  'fa-starfighter-twin-ion-engine-advanced',
  'fa-starfighter-alt-advanced',
  'fa-stars',
  'fa-starship',
  'fa-starship-freighter',
  'fa-steak',
  'fa-steering-wheel',
  'fa-sterling-sign',
  'fa-gbp',
  'fa-pound-sign',
  'fa-stethoscope',
  'fa-stocking',
  'fa-stomach',
  'fa-stop',
  'fa-stopwatch',
  'fa-stopwatch-20',
  'fa-store',
  'fa-store-lock',
  'fa-store-slash',
  'fa-strawberry',
  'fa-street-view',
  'fa-stretcher',
  'fa-strikethrough',
  'fa-stroopwafel',
  'fa-subscript',
  'fa-suitcase',
  'fa-suitcase-medical',
  'fa-medkit',
  'fa-suitcase-rolling',
  'fa-sun',
  'fa-sun-bright',
  'fa-sun-alt',
  'fa-sun-cloud',
  'fa-sun-dust',
  'fa-sun-haze',
  'fa-sunglasses',
  'fa-sunrise',
  'fa-sunset',
  'fa-superscript',
  'fa-sushi',
  'fa-nigiri',
  'fa-sushi-roll',
  'fa-maki-roll',
  'fa-makizushi',
  'fa-swatchbook',
  'fa-sword',
  'fa-sword-laser',
  'fa-sword-laser-alt',
  'fa-swords',
  'fa-swords-laser',
  'fa-symbols',
  'fa-icons-alt',
  'fa-synagogue',
  'fa-syringe',
  'fa-t',
  'fa-table',
  'fa-table-cells',
  'fa-th',
  'fa-table-cells-large',
  'fa-th-large',
  'fa-table-columns',
  'fa-columns',
  'fa-table-layout',
  'fa-table-list',
  'fa-th-list',
  'fa-table-picnic',
  'fa-table-pivot',
  'fa-table-rows',
  'fa-rows',
  'fa-table-tennis-paddle-ball',
  'fa-ping-pong-paddle-ball',
  'fa-table-tennis',
  'fa-table-tree',
  'fa-tablet',
  'fa-tablet-android',
  'fa-tablet-button',
  'fa-tablet-rugged',
  'fa-tablet-screen',
  'fa-tablet-android-alt',
  'fa-tablet-screen-button',
  'fa-tablet-alt',
  'fa-tablets',
  'fa-tachograph-digital',
  'fa-digital-tachograph',
  'fa-taco',
  'fa-tag',
  'fa-tags',
  'fa-tally',
  'fa-tally-5',
  'fa-tally-1',
  'fa-tally-2',
  'fa-tally-3',
  'fa-tally-4',
  'fa-tamale',
  'fa-tank-water',
  'fa-tape',
  'fa-taxi',
  'fa-cab',
  'fa-taxi-bus',
  'fa-teddy-bear',
  'fa-teeth',
  'fa-teeth-open',
  'fa-telescope',
  'fa-temperature-arrow-down',
  'fa-temperature-down',
  'fa-temperature-arrow-up',
  'fa-temperature-up',
  'fa-temperature-empty',
  'fa-temperature-0',
  'fa-thermometer-0',
  'fa-thermometer-empty',
  'fa-temperature-full',
  'fa-temperature-4',
  'fa-thermometer-4',
  'fa-thermometer-full',
  'fa-temperature-half',
  'fa-temperature-2',
  'fa-thermometer-2',
  'fa-thermometer-half',
  'fa-temperature-high',
  'fa-temperature-list',
  'fa-temperature-low',
  'fa-temperature-quarter',
  'fa-temperature-1',
  'fa-thermometer-1',
  'fa-thermometer-quarter',
  'fa-temperature-snow',
  'fa-temperature-frigid',
  'fa-temperature-sun',
  'fa-temperature-hot',
  'fa-temperature-three-quarters',
  'fa-temperature-3',
  'fa-thermometer-3',
  'fa-thermometer-three-quarters',
  'fa-tenge-sign',
  'fa-tenge',
  'fa-tennis-ball',
  'fa-terminal',
  'fa-text',
  'fa-text-height',
  'fa-text-size',
  'fa-text-slash',
  'fa-remove-format',
  'fa-text-width',
  'fa-thermometer',
  'fa-theta',
  'fa-thought-bubble',
  'fa-thumbs-down',
  'fa-thumbs-up',
  'fa-thumbtack',
  'fa-thumb-tack',
  'fa-tick',
  'fa-ticket',
  'fa-ticket-airline',
  'fa-ticket-simple',
  'fa-ticket-alt',
  'fa-tickets-airline',
  'fa-tilde',
  'fa-timeline',
  'fa-timeline-arrow',
  'fa-timer',
  'fa-tire',
  'fa-tire-flat',
  'fa-tire-pressure-warning',
  'fa-tire-rugged',
  'fa-toggle-off',
  'fa-toggle-on',
  'fa-toilet',
  'fa-toilet-paper',
  'fa-toilet-paper-blank',
  'fa-toilet-paper-alt',
  'fa-toilet-paper-blank-under',
  'fa-toilet-paper-reverse-alt',
  'fa-toilet-paper-slash',
  'fa-toilet-paper-under',
  'fa-toilet-paper-reverse',
  'fa-toilet-paper-under-slash',
  'fa-toilet-paper-reverse-slash',
  'fa-tomato',
  'fa-tombstone',
  'fa-tombstone-blank',
  'fa-tombstone-alt',
  'fa-toolbox',
  'fa-tooth',
  'fa-toothbrush',
  'fa-torii-gate',
  'fa-tornado',
  'fa-tower-broadcast',
  'fa-broadcast-tower',
  'fa-tower-control',
  'fa-tractor',
  'fa-trademark',
  'fa-traffic-cone',
  'fa-traffic-light',
  'fa-traffic-light-go',
  'fa-traffic-light-slow',
  'fa-traffic-light-stop',
  'fa-trailer',
  'fa-train',
  'fa-train-subway',
  'fa-subway',
  'fa-train-subway-tunnel',
  'fa-subway-tunnel',
  'fa-train-track',
  'fa-train-tram',
  'fa-tram',
  'fa-train-tunnel',
  'fa-transformer-bolt',
  'fa-transgender',
  'fa-transgender-alt',
  'fa-transporter',
  'fa-transporter-1',
  'fa-transporter-2',
  'fa-transporter-3',
  'fa-transporter-4',
  'fa-transporter-5',
  'fa-transporter-6',
  'fa-transporter-7',
  'fa-transporter-empty',
  'fa-trash',
  'fa-trash-arrow-up',
  'fa-trash-restore',
  'fa-trash-can',
  'fa-trash-alt',
  'fa-trash-can-arrow-up',
  'fa-trash-restore-alt',
  'fa-trash-can-check',
  'fa-trash-can-clock',
  'fa-trash-can-list',
  'fa-trash-can-plus',
  'fa-trash-can-slash',
  'fa-trash-alt-slash',
  'fa-trash-can-undo',
  'fa-trash-can-arrow-turn-left',
  'fa-trash-undo-alt',
  'fa-trash-can-xmark',
  'fa-trash-check',
  'fa-trash-clock',
  'fa-trash-list',
  'fa-trash-plus',
  'fa-trash-slash',
  'fa-trash-undo',
  'fa-trash-arrow-turn-left',
  'fa-trash-xmark',
  'fa-treasure-chest',
  'fa-tree',
  'fa-tree-christmas',
  'fa-tree-deciduous',
  'fa-tree-alt',
  'fa-tree-decorated',
  'fa-tree-large',
  'fa-tree-palm',
  'fa-trees',
  'fa-triangle',
  'fa-triangle-exclamation',
  'fa-exclamation-triangle',
  'fa-warning',
  'fa-triangle-instrument',
  'fa-triangle-music',
  'fa-triangle-person-digging',
  'fa-construction',
  'fa-trophy',
  'fa-trophy-star',
  'fa-trophy-alt',
  'fa-truck',
  'fa-truck-bolt',
  'fa-truck-clock',
  'fa-shipping-timed',
  'fa-truck-container',
  'fa-truck-container-empty',
  'fa-truck-fast',
  'fa-shipping-fast',
  'fa-truck-flatbed',
  'fa-truck-front',
  'fa-truck-medical',
  'fa-ambulance',
  'fa-truck-monster',
  'fa-truck-moving',
  'fa-truck-pickup',
  'fa-truck-plow',
  'fa-truck-ramp',
  'fa-truck-ramp-box',
  'fa-truck-loading',
  'fa-truck-ramp-couch',
  'fa-truck-couch',
  'fa-truck-tow',
  'fa-trumpet',
  'fa-tty',
  'fa-teletype',
  'fa-tty-answer',
  'fa-teletype-answer',
  'fa-tugrik-sign',
  'fa-turkey',
  'fa-turkish-lira-sign',
  'fa-try',
  'fa-turkish-lira',
  'fa-turn-down',
  'fa-level-down-alt',
  'fa-turn-down-left',
  'fa-turn-down-right',
  'fa-turn-up',
  'fa-level-up-alt',
  'fa-turntable',
  'fa-turtle',
  'fa-tv',
  'fa-television',
  'fa-tv-alt',
  'fa-tv-music',
  'fa-tv-retro',
  'fa-typewriter',
  'fa-u',
  'fa-ufo',
  'fa-ufo-beam',
  'fa-umbrella',
  'fa-umbrella-beach',
  'fa-umbrella-simple',
  'fa-umbrella-alt',
  'fa-underline',
  'fa-unicorn',
  'fa-uniform-martial-arts',
  'fa-union',
  'fa-universal-access',
  'fa-unlock',
  'fa-unlock-keyhole',
  'fa-unlock-alt',
  'fa-up',
  'fa-arrow-alt-up',
  'fa-up-down',
  'fa-arrows-alt-v',
  'fa-up-down-left-right',
  'fa-arrows-alt',
  'fa-up-from-dotted-line',
  'fa-up-from-line',
  'fa-arrow-alt-from-bottom',
  'fa-up-left',
  'fa-up-long',
  'fa-long-arrow-alt-up',
  'fa-up-right',
  'fa-up-right-and-down-left-from-center',
  'fa-expand-alt',
  'fa-up-right-from-square',
  'fa-external-link-alt',
  'fa-up-to-dotted-line',
  'fa-up-to-line',
  'fa-arrow-alt-to-top',
  'fa-upload',
  'fa-usb-drive',
  'fa-user',
  'fa-user-alien',
  'fa-user-astronaut',
  'fa-user-bounty-hunter',
  'fa-user-check',
  'fa-user-chef',
  'fa-user-clock',
  'fa-user-cowboy',
  'fa-user-crown',
  'fa-user-doctor',
  'fa-user-md',
  'fa-user-doctor-hair',
  'fa-user-doctor-hair-long',
  'fa-user-doctor-message',
  'fa-user-md-chat',
  'fa-user-gear',
  'fa-user-cog',
  'fa-user-graduate',
  'fa-user-group',
  'fa-user-friends',
  'fa-user-group-crown',
  'fa-users-crown',
  'fa-user-hair',
  'fa-user-hair-buns',
  'fa-user-hair-long',
  'fa-user-hair-mullet',
  'fa-business-front',
  'fa-party-back',
  'fa-trian-balbot',
  'fa-user-headset',
  'fa-user-helmet-safety',
  'fa-user-construction',
  'fa-user-hard-hat',
  'fa-user-injured',
  'fa-user-large',
  'fa-user-alt',
  'fa-user-large-slash',
  'fa-user-alt-slash',
  'fa-user-lock',
  'fa-user-minus',
  'fa-user-music',
  'fa-user-ninja',
  'fa-user-nurse',
  'fa-user-nurse-hair',
  'fa-user-nurse-hair-long',
  'fa-user-pen',
  'fa-user-edit',
  'fa-user-pilot',
  'fa-user-pilot-tie',
  'fa-user-plus',
  'fa-user-police',
  'fa-user-police-tie',
  'fa-user-robot',
  'fa-user-robot-xmarks',
  'fa-user-secret',
  'fa-user-shakespeare',
  'fa-user-shield',
  'fa-user-slash',
  'fa-user-tag',
  'fa-user-tie',
  'fa-user-tie-hair',
  'fa-user-tie-hair-long',
  'fa-user-unlock',
  'fa-user-visor',
  'fa-user-vneck',
  'fa-user-vneck-hair',
  'fa-user-vneck-hair-long',
  'fa-user-xmark',
  'fa-user-times',
  'fa-users',
  'fa-users-gear',
  'fa-users-cog',
  'fa-users-medical',
  'fa-users-slash',
  'fa-utensils',
  'fa-cutlery',
  'fa-utensils-slash',
  'fa-utility-pole',
  'fa-utility-pole-double',
  'fa-v',
  'fa-vacuum',
  'fa-vacuum-robot',
  'fa-value-absolute',
  'fa-van-shuttle',
  'fa-shuttle-van',
  'fa-vault',
  'fa-vector-circle',
  'fa-vector-polygon',
  'fa-vector-square',
  'fa-vent-damper',
  'fa-venus',
  'fa-venus-double',
  'fa-venus-mars',
  'fa-vest',
  'fa-vest-patches',
  'fa-vial',
  'fa-vials',
  'fa-video',
  'fa-video-camera',
  'fa-video-arrow-down-left',
  'fa-video-arrow-up-right',
  'fa-video-plus',
  'fa-video-slash',
  'fa-vihara',
  'fa-violin',
  'fa-virus',
  'fa-virus-covid',
  'fa-virus-covid-slash',
  'fa-virus-slash',
  'fa-viruses',
  'fa-voicemail',
  'fa-volcano',
  'fa-volleyball',
  'fa-volleyball-ball',
  'fa-volume',
  'fa-volume-medium',
  'fa-volume-high',
  'fa-volume-up',
  'fa-volume-low',
  'fa-volume-down',
  'fa-volume-off',
  'fa-volume-slash',
  'fa-volume-xmark',
  'fa-volume-mute',
  'fa-volume-times',
  'fa-vr-cardboard',
  'fa-w',
  'fa-waffle',
  'fa-wagon-covered',
  'fa-walker',
  'fa-walkie-talkie',
  'fa-wallet',
  'fa-wand',
  'fa-wand-magic',
  'fa-magic',
  'fa-wand-magic-sparkles',
  'fa-magic-wand-sparkles',
  'fa-wand-sparkles',
  'fa-warehouse',
  'fa-warehouse-full',
  'fa-warehouse-alt',
  'fa-washing-machine',
  'fa-washer',
  'fa-watch',
  'fa-watch-apple',
  'fa-watch-calculator',
  'fa-watch-fitness',
  'fa-watch-smart',
  'fa-water',
  'fa-water-arrow-down',
  'fa-water-lower',
  'fa-water-arrow-up',
  'fa-water-rise',
  'fa-water-ladder',
  'fa-ladder-water',
  'fa-swimming-pool',
  'fa-watermelon-slice',
  'fa-wave-pulse',
  'fa-heart-rate',
  'fa-wave-sine',
  'fa-wave-square',
  'fa-wave-triangle',
  'fa-waveform',
  'fa-waveform-lines',
  'fa-waveform-path',
  'fa-weight-hanging',
  'fa-weight-scale',
  'fa-weight',
  'fa-whale',
  'fa-wheat',
  'fa-wheat-awn',
  'fa-wheat-alt',
  'fa-wheat-awn-slash',
  'fa-wheat-slash',
  'fa-wheelchair',
  'fa-wheelchair-move',
  'fa-wheelchair-alt',
  'fa-whiskey-glass',
  'fa-glass-whiskey',
  'fa-whiskey-glass-ice',
  'fa-glass-whiskey-rocks',
  'fa-whistle',
  'fa-wifi',
  'fa-wifi-3',
  'fa-wifi-strong',
  'fa-wifi-exclamation',
  'fa-wifi-fair',
  'fa-wifi-2',
  'fa-wifi-slash',
  'fa-wifi-weak',
  'fa-wifi-1',
  'fa-wind',
  'fa-wind-turbine',
  'fa-wind-warning',
  'fa-wind-circle-exclamation',
  'fa-window',
  'fa-window-flip',
  'fa-window-alt',
  'fa-window-frame',
  'fa-window-frame-open',
  'fa-window-maximize',
  'fa-window-minimize',
  'fa-window-restore',
  'fa-windsock',
  'fa-wine-bottle',
  'fa-wine-glass',
  'fa-wine-glass-crack',
  'fa-fragile',
  'fa-wine-glass-empty',
  'fa-wine-glass-alt',
  'fa-won-sign',
  'fa-krw',
  'fa-won',
  'fa-wreath',
  'fa-wrench',
  'fa-wrench-simple',
  'fa-x',
  'fa-x-ray',
  'fa-xmark',
  'fa-close',
  'fa-multiply',
  'fa-remove',
  'fa-times',
  'fa-xmark-to-slot',
  'fa-times-to-slot',
  'fa-vote-nay',
  'fa-y',
  'fa-yen-sign',
  'fa-cny',
  'fa-jpy',
  'fa-rmb',
  'fa-yen',
  'fa-yin-yang',
  'fa-z',
] as const;

export type IconGlyph = (typeof fontAwesomeIcons)[number];

export const isIconGlyph = (glyph: unknown): glyph is IconGlyph => {
  return (
    typeof glyph === 'string' &&
    (fontAwesomeIcons as readonly string[]).includes(glyph)
  );
};

export type IconStyle = 'solid' | 'regular' | 'duotone';
